// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg height=\"6\" viewBox=\"0 0 10 6\" width=\"10\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"rgb%280,0,0%29\" opacity=\".6\" d=\"m6.6168815 3-4.44908109-4.09883609c-.22373388-.20615371-.22373388-.54039492 0-.74654863s.58647818-.20615371.81021206 0l4.85418712 4.47211041c.22373388.20615371.22373388.54039491 0 .74654862l-4.85418712 4.47211041c-.22373388.20615371-.58647818.20615371-.81021206 0s-.22373388-.54039492 0-.74654863z\" fill-rule=\"evenodd\" transform=\"matrix%280 1 -1 0 8 -2%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg height=\"6\" viewBox=\"0 0 10 6\" width=\"10\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"rgb%28255,255,255%29\" opacity=\"0.6\" d=\"m6.6168815 3-4.44908109-4.09883609c-.22373388-.20615371-.22373388-.54039492 0-.74654863s.58647818-.20615371.81021206 0l4.85418712 4.47211041c.22373388.20615371.22373388.54039491 0 .74654862l-4.85418712 4.47211041c-.22373388.20615371-.58647818.20615371-.81021206 0s-.22373388-.54039492 0-.74654863z\" fill-rule=\"evenodd\" transform=\"matrix%280 1 -1 0 8 -2%29\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --rx-font-ui: -apple-system, BlinkMacSystemFont, "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
  --rx-font-ui-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --rx-rounded-sm: 3px;
  --rx-rounded-md: 6px;
  --rx-rounded-lg: 9px;
  --rx-rounded-xl: 12px;
  --rx-rounded-circle: 99px;
  --rx-level-control: 3;
  --rx-level-toolbar: 5;
  --rx-level-tooltip: 99;
  --rx-level-popup: 100;
  --rx-outset-md: 28px;
  --rx-toolbar-height: 36px;
  --rx-toolbar-padding: 2px;
  --rx-toolbar-button-width: 34px;
  --rx-toolbar-button-height: 34px;
  --rx-toolbar-icon-size: 20px;
  --rx-fg-heading: #070707;
  --rx-fg-text: #2B2B3A;
  --rx-fg-subtle: #63636E;
  --rx-fg-placeholder: #73737C;
  --rx-bg-input: #FFFFFF;
  --rx-bg-input-shaded: #F7F7F8;
  --rx-bg-input-on: #070707;
  --rx-bg-input-off: rgba(7, 7, 7, 0.15);
  --rx-bg-input-disabled: rgba(7, 7, 7, 0.05);
  --rx-bg-aluminum: #f8f8f8;
  --rx-bg-silver: #E6E6E6;
  --rx-bg-platinum: #CDCDCD;
  --rx-bg-base: #FFFFFF;
  --rx-bg-raised: #FFFFFF;
  --rx-bg-overlay: #FFFFFF;
  --rx-bg-toolbar: rgba(255, 255, 255, 0.97);
  --rx-bg-toolbar-raised: rgba(255, 255, 255, 0.97);
  --rx-bg-context: #070707;
  --rx-bg-context-active: #042C6A;
  --rx-bg-source: #191919;
  --rx-border-divider: rgba(7, 7, 7, 0.1);
  --rx-border-input: rgba(7, 7, 7, 0.2);
  --rx-border-focus: #73A9FF;
  --rx-fg-dark-accent: #070707;
  --rx-fg-dark-heading: #070707;
  --rx-fg-dark-text: rgba(7, 7, 7, 0.8);
  --rx-fg-dark-subtle: rgba(7, 7, 7, 0.6);
  --rx-fg-dark-minimal: rgba(7, 7, 7, 0.5);
  --rx-fg-dark-dimmed: rgba(7, 7, 7, 0.4);
  --rx-bg-dark-dimmed: rgba(7, 7, 7, 0.03);
  --rx-bg-dark-minimal: rgba(7, 7, 7, 0.05);
  --rx-bg-dark-subtle: rgba(7, 7, 7, 0.08);
  --rx-bg-dark-medium: rgba(7, 7, 7, 0.15);
  --rx-bg-dark-strong: rgba(7, 7, 7, 0.25);
  --rx-bg-dark-accent: #070707;
  --rx-bg-dark-accent-hover: rgba(7, 7, 7, 0.8);
  --rx-border-dark-dimmed: rgba(7, 7, 7, 0.05);
  --rx-border-dark-minimal: rgba(7, 7, 7, 0.08);
  --rx-border-dark-subtle: rgba(7, 7, 7, 0.1);
  --rx-border-dark-medium: rgba(7, 7, 7, 0.2);
  --rx-border-dark-accent: #070707;
  --rx-fg-light-accent: #FFFFFF;
  --rx-fg-light-heading: #FFFFFF;
  --rx-fg-light-text: rgba(255, 255, 255, 0.8);
  --rx-fg-light-subtle: rgba(255, 255, 255, 0.6);
  --rx-fg-light-minimal: rgba(255, 255, 255, 0.5);
  --rx-fg-light-dimmed: rgba(255, 255, 255, 0.4);
  --rx-bg-light-dimmed: rgba(255, 255, 255, 0.03);
  --rx-bg-light-minimal: rgba(255, 255, 255, 0.05);
  --rx-bg-light-subtle: rgba(255, 255, 255, 0.08);
  --rx-bg-light-medium: rgba(255, 255, 255, 0.15);
  --rx-bg-light-strong: rgba(255, 255, 255, 0.25);
  --rx-bg-light-accent: #FFFFFF;
  --rx-bg-light-accent-hover: rgba(255, 255, 255, 0.8);
  --rx-border-light-dimmed: rgba(255, 255, 255, 0.05);
  --rx-border-light-minimal: rgba(255, 255, 255, 0.08);
  --rx-border-light-subtle: rgba(255, 255, 255, 0.1);
  --rx-border-light-medium: rgba(255, 255, 255, 0.2);
  --rx-border-light-accent: #FFFFFF;
  --rx-fg-black-accent: #070707;
  --rx-fg-black-heading: #070707;
  --rx-fg-black-text: rgba(7, 7, 7, 0.8);
  --rx-fg-black-subtle: rgba(7, 7, 7, 0.6);
  --rx-fg-black-minimal: rgba(7, 7, 7, 0.5);
  --rx-fg-black-dimmed: rgba(7, 7, 7, 0.4);
  --rx-bg-black-dimmed: rgba(7, 7, 7, 0.03);
  --rx-bg-black-minimal: rgba(7, 7, 7, 0.05);
  --rx-bg-black-subtle: rgba(7, 7, 7, 0.08);
  --rx-bg-black-medium: rgba(7, 7, 7, 0.15);
  --rx-bg-black-accent: #070707;
  --rx-bg-black-accent-hover: rgba(7, 7, 7, 0.8);
  --rx-border-black-dimmed: rgba(7, 7, 7, 0.05);
  --rx-border-black-minimal: rgba(7, 7, 7, 0.08);
  --rx-border-black-subtle: rgba(7, 7, 7, 0.1);
  --rx-border-black-medium: rgba(7, 7, 7, 0.2);
  --rx-border-black-accent: #070707;
  --rx-fg-white-accent: #FFFFFF;
  --rx-fg-white-heading: #FFFFFF;
  --rx-fg-white-text: rgba(255, 255, 255, 0.8);
  --rx-fg-white-subtle: rgba(255, 255, 255, 0.6);
  --rx-fg-white-minimal: rgba(255, 255, 255, 0.5);
  --rx-fg-white-dimmed: rgba(255, 255, 255, 0.4);
  --rx-bg-white-dimmed: rgba(255, 255, 255, 0.03);
  --rx-bg-white-minimal: rgba(255, 255, 255, 0.05);
  --rx-bg-white-subtle: rgba(255, 255, 255, 0.08);
  --rx-bg-white-medium: rgba(255, 255, 255, 0.15);
  --rx-bg-white-accent: #FFFFFF;
  --rx-bg-white-accent-hover: rgba(255, 255, 255, 0.8);
  --rx-border-white-dimmed: rgba(255, 255, 255, 0.05);
  --rx-border-white-minimal: rgba(255, 255, 255, 0.08);
  --rx-border-white-subtle: rgba(255, 255, 255, 0.1);
  --rx-border-white-medium: rgba(255, 255, 255, 0.2);
  --rx-border-white-accent: #FFFFFF;
  --rx-fg-primary-accent: #0063FF;
  --rx-fg-primary-strong: #0247B5;
  --rx-fg-primary-text: #043583;
  --rx-bg-primary-minimal: #F2F7FF;
  --rx-bg-primary-subtle: #E5EFFF;
  --rx-bg-primary-medium: #C9DEFF;
  --rx-bg-primary-accent: #0063FF;
  --rx-bg-primary-accent-hover: #0247B5;
  --rx-bg-primary-static: #0063FF;
  --rx-border-primary-minimal: #C9DEFF;
  --rx-border-primary-subtle: #99C1FF;
  --rx-border-primary-medium: #99C1FF;
  --rx-border-primary-accent: #0063FF;
  --rx-border-primary-static: #0063FF;
  --rx-fg-negative-accent: #D70015;
  --rx-fg-negative-strong: #990211;
  --rx-fg-negative-text: #6F040E;
  --rx-bg-negative-minimal: #FFF0F1;
  --rx-bg-negative-subtle: #FFE1E5;
  --rx-bg-negative-medium: #FFC1C8;
  --rx-bg-negative-accent: #D70015;
  --rx-bg-negative-accent-hover: #D70015;
  --rx-bg-negative-static: #D70015;
  --rx-border-negative-minimal: #FFC1C8;
  --rx-border-negative-subtle: #FF8994;
  --rx-border-negative-medium: #FF8994;
  --rx-border-negative-acccent: #D70015;
  --rx-border-negative-static: #D70015;
  --rx-link-color: #0063FF;
  --rx-link-hover-color: #070707;
  --rx-link-dark-color: #070707;
  --rx-link-dark-hover-color: rgba(7, 7, 7, 0.6);
  --rx-link-dark-subtle-color: rgba(7, 7, 7, 0.6);
  --rx-link-dark-subtle-hover-color: #070707;
  --rx-shadow-modal: 0 0 1px rgba(7, 7, 7, 0.25), 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);
  --rx-shadow-dropdown: 0 0 1px rgba(7, 7, 7, 0.25), 0 20px 24px -4px rgba(7, 7, 7, 0.08), 0 8px 8px -4px rgba(7, 7, 7, 0.04);
  --rx-shadow-toolbar-raised: 0 1px 3px rgba(7, 7, 7, 0.15), 0 1px 2px rgba(7, 7, 7, 0.06);
  --rx-shadow-reorder: 0 15px 30px rgba(7, 7, 7, 0.3);
  --rx-shadow-inner: inset 0 1px 1px rgba(7, 7, 7, 0.15);
  --rx-shadow-sm: 0 1px 3px rgba(7, 7, 7, 0.15);
  --rx-shadow-md: 0 1px 2px rgba(7, 7, 7, 0.05), 0 3px 6px rgba(7, 7, 7, 0.05), 0 2px 4px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05);
  --rx-shadow-lg: 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);
  --rx-shadow-sm-border: 0 0 1px rgba(7, 7, 7, 0.25), 0 1px 3px rgba(7, 7, 7, 0.15);
  --rx-shadow-md-border: 0 0 1px rgba(7, 7, 7, 0.25), 0 1px 2px rgba(7, 7, 7, 0.05), 0 3px 6px rgba(7, 7, 7, 0.05), 0 2px 4px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05);
  --rx-shadow-lg-border: 0 0 1px rgba(7, 7, 7, 0.25), 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);
}

[rx-data-theme=dark] {
  --rx-fg-heading: #D8D8DB;
  --rx-fg-text: #C8C8CC;
  --rx-fg-subtle: #73737C;
  --rx-fg-placeholder: #73737C;
  --rx-bg-input: #141414;
  --rx-bg-input-shaded: #141414;
  --rx-bg-input-on: #73A9FF;
  --rx-bg-input-off: rgba(255, 255, 255, 0.2);
  --rx-bg-input-disabled: rgba(255, 255, 255, 0.05);
  --rx-bg-aluminum: #191919;
  --rx-bg-silver: #1E1E1E;
  --rx-bg-platinum: #2F2F2F;
  --rx-bg-base: #141414;
  --rx-bg-raised: #191919;
  --rx-bg-overlay: #191919;
  --rx-bg-toolbar: rgba(25, 25, 25, 0.97);
  --rx-bg-toolbar-raised: rgba(25, 25, 25, 0.97);
  --rx-bg-context-active: #C9DEFF;
  --rx-border-divider: rgba(255, 255, 255, 0.1);
  --rx-border-input: rgba(255, 255, 255, 0.2);
  --rx-border-focus: #73A9FF;
  --rx-fg-dark-accent: #FFFFFF;
  --rx-fg-dark-heading: rgba(255, 255, 255, 0.9);
  --rx-fg-dark-text: rgba(255, 255, 255, 0.8);
  --rx-fg-dark-subtle: rgba(255, 255, 255, 0.6);
  --rx-fg-dark-minimal: rgba(255, 255, 255, 0.5);
  --rx-fg-dark-dimmed: rgba(255, 255, 255, 0.4);
  --rx-bg-dark-dimmed: rgba(255, 255, 255, 0.03);
  --rx-bg-dark-minimal: rgba(255, 255, 255, 0.05);
  --rx-bg-dark-subtle: rgba(255, 255, 255, 0.08);
  --rx-bg-dark-medium: rgba(255, 255, 255, 0.15);
  --rx-bg-dark-strong: rgba(255, 255, 255, 0.25);
  --rx-bg-dark-accent: #F7F7F8;
  --rx-bg-dark-accent-hover: rgba(255, 255, 255, 0.8);
  --rx-border-dark-dimmed: rgba(255, 255, 255, 0.05);
  --rx-border-dark-minimal: rgba(255, 255, 255, 0.08);
  --rx-border-dark-subtle: rgba(255, 255, 255, 0.1);
  --rx-border-dark-medium: rgba(255, 255, 255, 0.2);
  --rx-border-dark-accent: #F7F7F8;
  --rx-fg-light-accent: #070707;
  --rx-fg-light-heading: rgba(7, 7, 7, 0.9);
  --rx-fg-light-text: rgba(7, 7, 7, 0.8);
  --rx-fg-light-subtle: rgba(7, 7, 7, 0.6);
  --rx-fg-light-minimal: rgba(7, 7, 7, 0.5);
  --rx-fg-light-dimmed: rgba(7, 7, 7, 0.4);
  --rx-bg-light-dimmed: rgba(7, 7, 7, 0.03);
  --rx-bg-light-minimal: rgba(7, 7, 7, 0.05);
  --rx-bg-light-subtle: rgba(7, 7, 7, 0.08);
  --rx-bg-light-medium: rgba(7, 7, 7, 0.15);
  --rx-bg-light-strong: rgba(7, 7, 7, 0.25);
  --rx-bg-light-accent: #070707;
  --rx-bg-light-accent-hover: rgba(7, 7, 7, 0.8);
  --rx-border-light-dimmed: rgba(7, 7, 7, 0.05);
  --rx-border-light-minimal: rgba(7, 7, 7, 0.08);
  --rx-border-light-subtle: rgba(7, 7, 7, 0.1);
  --rx-border-light-medium: rgba(7, 7, 7, 0.2);
  --rx-border-light-accent: #070707;
  --rx-fg-primary-accent: #73A9FF;
  --rx-fg-primary-strong: #99C1FF;
  --rx-fg-primary-text: #C9DEFF;
  --rx-bg-primary-minimal: #070D18;
  --rx-bg-primary-subtle: #061939;
  --rx-bg-primary-medium: #042C6A;
  --rx-bg-primary-accent: #73A9FF;
  --rx-bg-primary-accent-hover: #99C1FF;
  --rx-bg-primary-static: #0063FF;
  --rx-border-primary-minimal: #042C6A;
  --rx-border-primary-subtle: #043583;
  --rx-border-primary-medium: #043583;
  --rx-border-primary-accent: #73A9FF;
  --rx-border-primary-static: #0063FF;
  --rx-fg-negative-accent: #FF5D6C;
  --rx-fg-negative-strong: #FF8994;
  --rx-fg-negative-text: #FFC1C8;
  --rx-bg-negative-minimal: #160708;
  --rx-bg-negative-subtle: #31060A;
  --rx-bg-negative-medium: #5A040D;
  --rx-bg-negative-accent: #FF5D6C;
  --rx-bg-negative-accent-hover: #FF8994;
  --rx-bg-negative-static: #D70015;
  --rx-border-negative-minimal: #5A040D;
  --rx-border-negative-subtle: #6F040E;
  --rx-border-negative-medium: #6F040E;
  --rx-border-negative-accent: #FF5D6C;
  --rx-border-negative-static: #D70015;
  --rx-link-color: #73A9FF;
  --rx-link-hover-color: #FFFFFF;
  --rx-link-dark-color: #FFFFFF;
  --rx-link-dark-hover-color: rgba(255, 255, 255, 0.6);
  --rx-link-dark-subtle-color: rgba(255, 255, 255, 0.6);
  --rx-link-dark-subtle-hover-color: #FFFFFF;
  --rx-shadow-modal: 0 0 1px rgba(255, 255, 255, 0.5), 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);
  --rx-shadow-dropdown: 0 0 1px rgba(255, 255, 255, 0.4), 0 20px 24px -4px rgba(7, 7, 7, 0.08), 0 8px 8px -4px rgba(7, 7, 7, 0.04);
  --rx-shadow-sm-border: 0 0 1px rgba(255, 255, 255, 0.5), 0 1px 3px rgba(7, 7, 7, 0.15);
  --rx-shadow-md-border: 0 0 1px rgba(255, 255, 255, 0.5), 0 1px 2px rgba(7, 7, 7, 0.05), 0 3px 6px rgba(7, 7, 7, 0.05), 0 2px 4px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05);
  --rx-shadow-lg-border: 0 0 1px rgba(255, 255, 255, 0.5), 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);
}

@keyframes slideUp {
  to {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-bottom: 0;
  }
}
@keyframes slideDown {
  from {
    height: 0;
    padding-top: 0;
    padding-bottom: 0;
    margin-bottom: 0;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
.rx-container {
  position: relative;
  box-sizing: border-box;
}

.rx-container.rx-fullscreen {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 10000;
  overflow-x: auto;
}

.rx-main-container {
  border-radius: var(--rx-rounded-sm);
  background-color: var(--rx-bg-base);
  border: 1px solid var(--rx-border-dark-minimal);
}

.rx-main-wym {
  background-color: var(--rx-bg-aluminum);
}

.rx-stop-scrolling {
  height: 100%;
  overflow: hidden;
}

.rx-editor-frame {
  width: 100%;
  height: 0;
  border: none;
  background-color: var(--rx-bg-base);
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.rx-editor-container {
  box-sizing: border-box;
}

.rx-editor-disabled {
  opacity: 0.4;
}
.rx-editor-disabled img {
  filter: grayscale(1);
}

.rx-editor-overlay {
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 1;
  background: transparent;
  top: 0;
  left: 0;
}

.rx-toolbox-container {
  background: var(--rx-bg-toolbar);
  z-index: var(--rx-level-toolbar);
}

.rx-editor-breakline table + *, .rx-editor-breakline blockquote + *, .rx-editor-breakline figure + *, .rx-editor-breakline > div + *,
.rx-editor-breakline p + *, .rx-editor-breakline ul + *, .rx-editor-breakline ol + *, .rx-editor-breakline pre + *, .rx-editor-breakline dl + *, .rx-editor-breakline address + * {
  margin-top: 0 !important;
}
.rx-editor-breakline h1 + h2,
.rx-editor-breakline h2 + h3,
.rx-editor-breakline h3 + h4,
.rx-editor-breakline h4 + h5,
.rx-editor-breakline h5 + h6 {
  margin-top: 0 !important;
}

.rx-editor {
  overflow: hidden;
}
.rx-editor *, .rx-editor *::before, .rx-editor *::after {
  box-sizing: inherit;
}

.rx-editor {
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
}
.rx-editor *[dir=rtl] {
  text-align: right;
}
.rx-editor *[dir=ltr] {
  text-align: left;
}
.rx-editor, .rx-editor [data-rx-type], .rx-editor a, .rx-editor p, .rx-editor figcaption, .rx-editor td, .rx-editor th {
  outline: none;
}
.rx-editor [data-rx-tag=tbr], .rx-editor [data-rx-tag=br] {
  margin-top: 0;
}
.rx-editor [data-rx-tag=tbr]:empty, .rx-editor [data-rx-tag=br]:empty, .rx-editor [data-rx-type=text]:empty, .rx-editor [data-rx-type=todoitem] div:empty {
  min-width: 1em;
  min-height: 1.5em;
}
.rx-editor::after {
  content: "";
  clear: both;
  display: table;
}
.rx-editor [data-rx-type=embed],
.rx-editor [data-rx-type=image] {
  position: relative;
}
.rx-editor [data-rx-type=embed] img,
.rx-editor [data-rx-type=image] img {
  vertical-align: middle;
}
.rx-editor figure > img, .rx-editor figure > a img, .rx-editor figure > iframe, .rx-editor figure > pre, .rx-editor figure > div {
  vertical-align: middle;
}
.rx-editor [data-rx-focusable].rx-block-focus {
  outline: 2px solid var(--rx-border-focus) !important;
}
.rx-editor .rx-block-control-focus {
  outline: 1px solid var(--rx-border-focus) !important;
  outline-offset: 1px;
}
.rx-editor [data-rx-type=wrapper]:empty {
  outline: 1px dashed var(--rx-border-dark-medium);
  outline-offset: 1px;
}
.rx-editor [data-rx-type=heading] a {
  text-decoration: underline;
}
.rx-editor .rx-layout-grid {
  display: flex;
  flex-direction: row;
  gap: 24px;
}
.rx-editor [data-rx-type=column] {
  outline: 1px dashed var(--rx-border-dark-medium);
}
.rx-editor.rx-editor-email [data-rx-type=column] {
  outline: none;
}
.rx-editor.rx-editor-email [data-rx-type=column]:hover, .rx-editor.rx-editor-email [data-rx-type=column]:has(p:empty) {
  outline: 1px dashed var(--rx-border-dark-medium);
}
.rx-editor .rx-nowrap {
  white-space: nowrap;
}
.rx-editor [data-rx-type=pre] {
  position: relative;
}
.rx-editor [data-rx-type=embed] {
  position: relative;
}
.rx-editor [data-rx-type=embed]:before {
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 1;
}
.rx-editor [data-rx-type=embed] iframe {
  display: inline-block;
}
.rx-editor [data-rx-type=embed] figcaption {
  position: relative;
  top: 0;
  z-index: 2;
}
.rx-editor [data-rx-type=embed].rx-block-focus:before {
  display: none;
}
.rx-editor .rx-embed-placeholder {
  text-align: center;
  border: 1px dashed var(--rx-border-dark-medium);
  border-radius: var(--rx-rounded-md);
  padding: 40px 20px;
  font-size: 14px;
  color: var(--rx-fg-placeholder);
}
.rx-editor [data-rx-type=todo] {
  --rx-todo-size: 20px;
  --rx-todo-mark-color: var(--rx-fg-light-accent);
  --rx-todo-border-color: var(--rx-border-input);
  --rx-todo-bg: var(--rx-bg-input);
  --rx-todo-checked-border-color: var(--rx-border-dark-accent);
  --rx-todo-checked-bg: var(--rx-bg-dark-accent);
  margin-left: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.rx-editor [data-rx-type=todoitem] {
  display: flex;
  gap: 6px;
  cursor: text;
}
.rx-editor [data-rx-type=todoitem] input {
  position: relative;
  top: 1px;
  appearance: none;
  display: inline-block;
  padding: 0;
  box-shadow: none;
  width: var(--rx-todo-size);
  height: var(--rx-todo-size);
  cursor: pointer;
}
.rx-editor [data-rx-type=todoitem] input:before {
  content: "";
  display: block;
  width: var(--rx-todo-size);
  height: var(--rx-todo-size);
  border: 1px solid var(--rx-todo-border-color);
  border-radius: 6px;
  background: var(--rx-todo-bg);
}
.rx-editor [data-rx-type=todoitem] input:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: calc(var(--rx-todo-size) / 3.5);
  height: calc(var(--rx-todo-size) / 1.8);
  background-color: transparent;
  transform: translate(-50%, -85%) scale(0) rotate(45deg);
}
.rx-editor [data-rx-type=todoitem] input:checked:before {
  border-color: var(--rx-todo-checked-border-color);
  background-color: var(--rx-todo-checked-bg);
  box-shadow: var(--rx-todo-checked-shadow);
}
.rx-editor [data-rx-type=todoitem] input:checked:after {
  transform: translate(-50%, -85%) scale(1) rotate(45deg);
  box-shadow: 2px 2px 0px 0px var(--rx-todo-mark-color);
}
.rx-editor [data-rx-type=todoitem] div {
  outline: none;
  line-height: 1.4;
}
.rx-editor [data-rx-type=mergetag] {
  font-family: var(--rx-font-ui-mono);
  font-size: 85%;
  line-height: 1;
  display: inline-block;
  cursor: pointer;
  padding: 4px 6px;
  color: var(--rx-fg-primary-text);
  background: var(--rx-bg-primary-subtle);
  border: 1px solid var(--rx-border-primary-subtle);
  border-radius: 4px;
}
.rx-editor [data-rx-type=mergetag]:hover, .rx-editor [data-rx-type=mergetag].rx-block-focus {
  background: var(--rx-bg-primary-medium);
}
.rx-editor .rx-block-placeholder {
  position: relative;
}
.rx-editor .rx-block-placeholder:before {
  position: absolute;
}
.rx-editor .rx-block-placeholder:before,
.rx-editor [data-placeholder]:empty:before {
  content: attr(data-placeholder);
  display: inline-block;
  color: var(--rx-fg-placeholder);
  font-weight: normal;
  font-style: italic;
  font-size: inherit;
  cursor: text;
  max-height: 20px;
}
.rx-editor [data-placeholder]:empty:focus:before {
  content: "";
}

.rx-editor.rx-placeholder:before {
  position: absolute;
  z-index: 0;
  content: attr(placeholder);
  color: var(--rx-fg-placeholder);
  font-weight: normal;
  cursor: text;
}

.rx-in-blur .rx-editor [data-rx-focusable].rx-block-focus {
  outline-color: var(--rx-border-dark-medium) !important;
}

.rx-draggable-placeholder {
  height: 20px;
  min-width: 80px;
  outline: 3px dashed gold !important;
  background: rgba(255, 215, 0, 0.2) !important;
  margin-bottom: 20px;
}

.rx-toolbar-container {
  display: flex;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.rx-toolbar-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.rx-toolbar-container:empty {
  display: none;
}

.rx-sticky {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.rx-sticky-on {
  border-bottom: 1px solid var(--rx-border-dark-minimal);
}

.rx-raised {
  margin-left: -1px;
  margin-right: -1px;
  margin-top: -1px;
  margin-bottom: -1px;
  background: var(--rx-bg-toolbar-raised);
  box-shadow: var(--rx-shadow-toolbar-raised);
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.rx-toolbox-external.rx-raised {
  margin: 0;
}

.rx-raised.rx-sticky-on {
  border-bottom: none;
}

.rx-toolbar-buttons,
.rx-extrabar-buttons {
  display: flex;
  white-space: nowrap;
  align-items: center;
  gap: 1px;
}

.rx-toolbar,
.rx-extrabar {
  padding: var(--rx-toolbar-padding);
  height: var(--rx-toolbar-height);
}

.rx-toolbar {
  order: 1;
  flex: 1;
}

.rx-extrabar {
  order: 2;
}

.rx-toolbar .rx-button,
.rx-extrabar .rx-button {
  justify-content: center;
  width: var(--rx-toolbar-button-width);
  height: var(--rx-toolbar-button-height);
}
.rx-toolbar .rx-button-icon,
.rx-extrabar .rx-button-icon {
  width: var(--rx-toolbar-button-width);
  min-width: var(--rx-toolbar-button-width);
  height: var(--rx-toolbar-button-height);
}
.rx-toolbar .rx-button-icon svg,
.rx-extrabar .rx-button-icon svg {
  width: var(--rx-toolbar-icon-size);
  height: var(--rx-toolbar-icon-size);
}
.rx-toolbar .rx-button-title,
.rx-extrabar .rx-button-title {
  display: none;
}

.rx-pathbar {
  font-family: var(--rx-font-ui);
  margin: 0;
  padding: 0 8px;
  position: relative;
  overflow: hidden;
  background: var(--rx-bg-toolbar);
  box-sizing: border-box;
  border: none;
  display: flex;
  gap: 12px;
  border-bottom: 1px solid var(--rx-border-dark-dimmed);
}
.rx-pathbar:empty {
  display: none;
}

.rx-pathbar.disable .rx-pathbar-item {
  opacity: 0.5;
}

.rx-pathbar-item {
  position: relative;
  font-size: 12px;
  padding: 6px 0;
  margin: 0;
  line-height: 16px;
  color: var(--rx-fg-dark-minimal);
  cursor: pointer;
}

.rx-pathbar-item:hover {
  color: var(--rx-fg-dark-accent);
  text-decoration: underline;
}

.rx-pathbar-item.active,
.rx-pathbar-item.active:hover {
  color: var(--rx-fg-dark-accent);
  text-decoration: none;
  cursor: text;
}

.rx-pathbar-item:after {
  position: absolute;
  content: "-";
  width: 8px;
  padding-left: 3px;
  font-size: 12px;
  line-height: 16px;
  color: var(--rx-fg-dark-minimal);
}

.rx-pathbar-item:last-child:after {
  display: none;
}

.rx-statusbar {
  font-family: var(--rx-font-ui-mono);
  margin: 0;
  padding: 8px 10px;
  position: relative;
  overflow: hidden;
  background: var(--rx-bg-base);
  box-sizing: border-box;
  border: none;
  display: flex;
  align-items: center;
  gap: 10px;
}
.rx-statusbar:empty {
  display: none;
}

.rx-statusbar-start,
.rx-statusbar-end {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rx-statusbar-start {
  flex: auto;
}

.rx-statusbar.disable .rx-statusbar-item {
  opacity: 0.5;
}

.rx-statusbar-item {
  font-size: 12px;
  padding: 0;
  margin: 0;
  line-height: 16px;
  color: var(--rx-fg-text);
}

.rx-statusbar-item:after {
  content: "";
  display: inline-block;
  position: relative;
  top: 2px;
  width: 1px;
  height: 12px;
  margin-left: 10px;
  background: var(--rx-border-divider);
}

.rx-statusbar-item:last-child:after {
  display: none;
}

.rx-statusbar-item a {
  color: var(--rx-link-dark-color);
  text-decoration: underline;
}

.rx-statusbar-item a:hover {
  color: var(--rx-link-dark-hover-color);
  text-decoration: underline;
}

.rx-fullscreen .rx-statusbar {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.rx-control {
  position: absolute;
  top: 0;
  left: 0;
  font-family: var(--rx-font-text);
  z-index: var(--rx-level-control);
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  width: 28px;
  line-height: 0;
}

.rx-control-buttons {
  display: flex;
  gap: 1;
  flex-direction: column;
  flex-wrap: wrap;
}

.rx-control .rx-button {
  justify-content: center;
  background: var(--rx-bg-raised);
}
.rx-control .rx-button-title {
  display: none;
}
.rx-control .rx-button-icon svg {
  width: 14px;
  height: 14px;
}

.rx-context {
  font-family: var(--rx-font-text);
  position: absolute;
  top: 0;
  left: 0;
  z-index: var(--rx-level-toolbar);
  border-radius: var(--rx-rounded-lg);
  padding: 4px 6px;
  margin: 0;
  line-height: 1;
  background: var(--rx-bg-context);
  box-shadow: var(--rx-shadow-sm-border);
  max-width: 380px;
}

.rx-context-line {
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  padding: 6px;
  padding-bottom: 8px;
  border-radius: var(--rx-rounded-sm);
  display: flex;
  align-items: center;
  vertical-align: baseline;
}
.rx-context-line, .rx-context-line a {
  color: var(--rx-fg-white-text);
}
.rx-context-line a:hover {
  color: var(--rx-fg-white-subtle);
}

.rx-context-buttons {
  display: flex;
  align-items: center;
  gap: 1px;
  flex-wrap: wrap;
}

.rx-context .rx-button {
  justify-content: center;
}
.rx-context .rx-button:hover, .rx-context .rx-button.toggled, .rx-context .rx-button.active {
  background: var(--rx-bg-white-medium);
}
.rx-context .rx-button:hover .rx-button-icon svg, .rx-context .rx-button.toggled .rx-button-icon svg, .rx-context .rx-button.active .rx-button-icon svg {
  fill: var(--rx-fg-white-text);
}
.rx-context .rx-button.disabled .rx-button-icon svg {
  fill: var(--rx-fg-white-dimmed);
}
.rx-context .rx-button-icon {
  border-radius: var(--rx-rounded-md);
}
.rx-context .rx-button-icon svg {
  fill: var(--rx-fg-white-text);
  width: 18px;
  height: 18px;
}
.rx-context .rx-button-title {
  display: none;
}

.rx-button {
  font-family: var(--rx-font-text);
  display: flex;
  align-items: center;
  vertical-align: middle;
  text-decoration: none;
  background: none;
  outline: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 0px;
  line-height: 1;
  gap: 8px;
  border-radius: var(--rx-rounded-sm);
  width: 28px;
  height: 28px;
  transition: none;
  cursor: pointer;
}
.rx-button.pressed {
  background: var(--rx-bg-silver);
}
.rx-button.pressed .rx-button-icon svg {
  fill: var(--rx-fg-dark-accent);
}
.rx-button:hover {
  text-decoration: none;
}
.rx-button:hover {
  background: var(--rx-bg-silver);
}
.rx-button:hover .rx-button-icon svg {
  fill: var(--rx-fg-dark-accent);
}
.rx-button.active {
  background: var(--rx-bg-silver);
}
.rx-button.disabled {
  cursor: default;
  background-color: transparent !important;
}
.rx-button.disabled .rx-button-icon svg {
  fill: var(--rx-fg-dark-dimmed);
}

.rx-button-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  border-radius: var(--rx-rounded-sm);
  width: 28px;
  min-width: 28px;
  height: 28px;
}
.rx-button-icon:empty {
  display: none;
}
.rx-button-icon svg {
  fill: var(--rx-fg-dark-text);
  width: 16px;
  height: 16px;
}

.rx-button-title {
  font-size: 14px;
  font-weight: normal;
  line-height: 1.4;
  color: var(--rx-fg-dark-text);
}

.rx-tooltip {
  position: absolute;
  z-index: 99;
  margin: 0;
  padding: 4px 7px;
  border-radius: var(--rx-rounded-sm);
  line-height: 1;
  font-family: var(--rx-font-ui-mono);
  font-size: 12px;
  font-weight: 500;
  color: var(--rx-fg-white-text);
  background: var(--rx-bg-black-accent);
  pointer-events: none;
}

.rx-source-container {
  display: none;
}

.rx-source,
.rx-source:hover,
.rx-source:focus {
  text-align: left;
  box-sizing: border-box;
  font-family: var(--rx-font-ui-mono);
  width: 100%;
  display: block;
  margin: 0;
  border: none;
  box-shadow: none;
  border-radius: 0;
  background-color: var(--rx-bg-source);
  color: var(--rx-fg-white-text);
  font-size: 14px;
  line-height: 1.7;
  outline: none;
  padding: 10px 18px 20px 18px;
  min-height: 60px;
  resize: vertical;
}

.rx-drag-active {
  outline: 3px dashed gold !important;
  outline-offset: 0 !important;
  position: relative;
  max-height: 40px;
  overflow: hidden;
  padding: 0;
}
.rx-drag-active:before {
  width: 100%;
  height: 100%;
  content: "";
  top: 0;
  left: 0;
  background: rgba(255, 215, 0, 0.4);
  position: absolute;
  z-index: 1;
}

.rx-dragging {
  opacity: 0.95;
  padding: 8px;
  background: var(--rx-bg-body);
  box-shadow: var(--rx-shadow-reorder);
}
.rx-dragging img {
  max-width: 100%;
}

.rx-dropdown,
.rx-colorpicker {
  position: absolute;
  font-family: var(--rx-font-ui);
  border-radius: var(--rx-rounded-md);
  background: var(--rx-bg-overlay);
  box-shadow: var(--rx-shadow-dropdown);
  position: absolute;
  top: 0;
  left: 0;
  font-size: 14px;
  line-height: 1.4;
  z-index: var(--rx-level-popup);
  margin-bottom: 16px;
  overflow-x: auto;
  min-width: 200px;
  padding: 4px;
}

.rx-dropdown[data-rx-pos=top] {
  box-shadow: none;
}

.rx-dropdown-swatches {
  display: flex;
  flex-wrap: nowrap;
}

.rx-dropdown-swatches-wrap {
  flex-wrap: wrap;
}

.rx-dropdown-swatches-colors {
  display: flex;
  flex-direction: column;
}

.rx-dropdown-swatches-colors-row {
  flex-direction: row;
}

.rx-dropdown-swatch {
  cursor: pointer;
  position: relative;
  font-size: 0;
  width: 20px;
  height: 20px;
  border: 1px solid transparent;
}
.rx-dropdown-swatch.active {
  border: 2px solid var(--rx-border-dark-accent);
  box-shadow: 0 0 0 2px var(--rx-border-light-accent);
  z-index: 2;
}

.rx-dropdown-swatch-size-large {
  width: 32px;
  height: 32px;
}

.rx-dropdown-color-contrast {
  border-color: var(--rx-border-dark-subtle);
}

.rx-dropdown-tabs {
  font-size: 13px;
  line-height: 1;
  font-weight: 500;
  display: flex;
  gap: 2px;
  border-radius: var(--rx-rounded-sm);
  background: var(--rx-bg-dark-minimal);
  padding: 2px;
  margin-bottom: 4px;
}

.rx-dropdown-tab {
  flex-grow: 1;
  border-radius: var(--rx-rounded-sm);
  padding: 6px 8px;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  color: var(--rx-fg-dark-subtle);
}

.rx-dropdown-tab:hover,
.rx-dropdown-tab.active {
  text-decoration: none;
  background: var(--rx-bg-dark-subtle);
  color: var(--rx-fg-dark-text);
}

.rx-dropdown-tab.active {
  cursor: text;
  text-decoration: none;
  background: var(--rx-bg-light-accent);
  color: var(--rx-fg-dark-text);
  box-shadow: var(--shadow-sm-border);
}

.rx-dropdown-item,
.rx-dropdown-item:hover {
  font-size: 14px;
  line-height: 1.4;
  padding: 6px;
  display: flex;
  color: var(--rx-fg-dark-text);
  background: none;
  cursor: default;
  border-bottom: 1px solid var(--rx-border-dark-dimmed);
}
.rx-dropdown-item .rx-button-title,
.rx-dropdown-item:hover .rx-button-title {
  display: none;
}

.rx-dropdown-item:last-child {
  border-bottom-width: 0;
}

.rx-dropdown-item-hotkey {
  margin-left: auto;
  font-weight: normal;
  display: flex;
  gap: 1px;
  align-items: center;
  color: var(--rx-fg-dark-minimal);
  font-family: var(--rx-font-ui);
  font-size: 12px;
  line-height: 16px;
}
.rx-dropdown-item-hotkey span {
  padding: 0 2px;
  height: 16px;
}

.rx-dropdown .rx-button {
  position: relative;
  padding: 8px 10px;
  height: auto;
  width: 100%;
  border-radius: var(--rx-rounded-md);
}
.rx-dropdown .rx-button-icon {
  width: 16px;
  min-width: 16px;
  height: 16px;
}
.rx-dropdown .rx-button.rx-button-swatch {
  width: 20px;
  height: 20px;
  border-radius: 0;
}
.rx-dropdown .rx-button.rx-button-swatch .rx-button-icon,
.rx-dropdown .rx-button.rx-button-swatch .rx-button-title {
  display: none;
}
.rx-dropdown .rx-button-title {
  color: var(--rx-fg-dark-accent);
}
.rx-dropdown .rx-button-danger .rx-button-title {
  color: var(--rx-fg-negative-accent);
}
.rx-dropdown .rx-button-danger svg {
  fill: var(--rx-fg-negative-accent);
}
.rx-dropdown .rx-button.disabled .rx-button-title {
  color: var(--rx-fg-dark-minimal);
}
.rx-dropdown .rx-button.disabled svg {
  fill: var(--rx-fg-dark-minimal);
}

.rx-dropdown-type-grid .rx-dropdown-items {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  box-sizing: border-box;
}
.rx-dropdown-type-grid .rx-button {
  box-sizing: border-box;
  border-radius: 0;
  margin-bottom: -1px;
  width: 32px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  text-align: center;
  justify-content: center;
  align-items: center;
  color: var(--rx-fg-dark-text);
}
.rx-dropdown-type-grid .rx-button:after {
  display: none;
}
.rx-dropdown-type-grid .rx-button-title:empty {
  display: none;
}
.rx-dropdown-type-grid .rx-dropdown-item svg {
  width: 16px;
  height: 16px;
}

.rx-dropdown-stack {
  padding: 16px;
  padding-top: 0;
}

.rx-dropdown-stack-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  border-radius: 4px;
  line-height: 1;
  border-bottom: 1px solid var(--rx-border-dark-dimmed);
}

.rx-dropdown-stack-item:last-child {
  border-bottom-color: transparent;
}

.rx-dropdown-stack-item:hover {
  background-color: var(--rx-bg-dark-minimal);
}

.rx-dropdown-stack-title {
  text-decoration: none;
  flex: 1;
  padding: 7px 8px;
  font-size: 14px;
  color: var(--rx-fg-dark-text);
}

.rx-dropdown-stack-aside {
  font-family: var(--rx-font-ui-mono);
  font-size: 11px;
  color: var(--rx-fg-dark-subtle);
  margin-left: auto;
  padding-left: 4px;
}

.rx-modal {
  position: absolute;
  overflow-x: hidden;
  overflow-y: auto;
  margin-bottom: 16px;
  min-width: 200px;
  font-family: var(--rx-font-ui);
  border-radius: var(--rx-rounded-md);
  background-color: var(--rx-bg-overlay);
  box-shadow: var(--rx-shadow-modal);
  z-index: var(--rx-level-popup);
}

.rx-modal-body .rx-form {
  padding-bottom: 0;
}

.rx-modal-header {
  font-size: 16px;
  font-weight: bold;
  color: var(--rx-bg-dark-accent);
  padding: 16px;
  position: relative;
}
.rx-modal-header:empty {
  display: none;
}

.rx-modal-footer {
  overflow: hidden;
  box-sizing: border-box;
  margin-top: 8px;
  padding: 16px;
  padding-bottom: 20px;
  display: flex;
  gap: 4px;
}
.rx-modal-footer:empty {
  display: none;
}

.rx-modal-close {
  position: absolute !important;
  right: 16px;
  top: 14px;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  opacity: 0.5;
}
.rx-modal-close::before, .rx-modal-close::after {
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  background: var(--rx-bg-dark-accent);
}
.rx-modal-close::before {
  height: 1px;
  width: 75%;
}
.rx-modal-close::after {
  height: 75%;
  width: 1px;
}
.rx-modal-close:hover {
  opacity: 1;
}

.rx-modal-tabs {
  margin: 0 16px;
  padding: 0;
  border: 1px solid var(--rx-border-dark-dimmed);
  border-radius: 99px;
  display: inline-flex;
  gap: 0;
}

.rx-modal-tab {
  font-size: 14px;
  font-weight: normal;
  color: var(--rx-fg-text);
  text-decoration: none;
  border-radius: 99px;
  padding: 8px 16px;
  line-height: 1;
}

.rx-modal-tab:hover {
  color: var(--rx-fg-text);
  background: var(--rx-bg-dark-minimal);
}

.rx-modal-tab.active {
  color: var(--rx-fg-light-accent);
  background: var(--rx-bg-dark-accent);
}

.rx-form {
  padding: 0 16px 0 16px;
}
.rx-form-item {
  padding-bottom: 16px;
}
.rx-form-item:empty {
  display: none;
}
.rx-form-box {
  padding: 16px;
}
.rx-form-image img, .rx-form-image svg {
  max-width: 100%;
}
.rx-form-title, .rx-form-section {
  font-size: 14px;
  font-weight: 600;
  color: var(--rx-bg-dark-accent);
  padding: 16px 0;
}
.rx-form-title:empty, .rx-form-section:empty {
  display: none;
}
.rx-form-label {
  box-sizing: border-box;
  font-family: var(--rx-font-ui);
  font-size: 14px;
  line-height: 1.4;
  font-weight: 500;
  display: block;
  padding: 0;
  margin: 0;
  padding-bottom: 6px;
  color: var(--rx-fg-dark-text);
}
.rx-form-hint {
  font-size: 13px;
  font-weight: normal;
  color: var(--rx-fg-dark-subtle);
  margin-left: 2px;
}

.rx-form-flex {
  display: flex;
  gap: 8px;
}
.rx-form-flex .rx-form-input,
.rx-form-flex .rx-form-select {
  flex: auto;
}

.rx-form-color-container {
  position: relative;
}
.rx-form-color-container .rx-form-input {
  padding-left: 40px;
}

.rx-form-color-toggle {
  position: absolute;
  top: 4px;
  left: 6px;
  height: 28px;
  width: 28px;
  border-radius: 8px;
  box-shadow: var(--rx-shadow-inner);
  cursor: pointer;
  background: var(--rx-bg-white-accent);
}

.rx-form-button {
  box-sizing: border-box;
  font-family: var(--rx-font-ui);
  font-size: 14px;
  font-weight: 500;
  outline: none;
  border-radius: 6px;
  padding: 8px 20px;
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  line-height: 1.25;
  height: auto;
  background: transparent;
  color: var(--rx-fg-dark-accent);
  border: 1px solid var(--rx-border-dark-medium);
}
.rx-form-button:hover {
  background: var(--rx-bg-dark-subtle);
}
.rx-form-button-primary {
  background: var(--rx-bg-dark-accent);
  color: var(--rx-fg-light-accent);
  border-color: transparent;
}
.rx-form-button-primary:hover {
  color: var(--rx-fg-light-accent);
  background: var(--rx-bg-dark-accent-hover);
}
.rx-form-button-danger {
  border: 1px solid var(--rx-border-negative-medium);
  color: var(--rx-fg-negative-accent);
}
.rx-form-button-danger:hover {
  color: var(--rx-fg-negative-accent);
  background: var(--rx-bg-negative-subtle);
}
.rx-form-button-fullwidth {
  display: block;
  width: 100%;
}
.rx-form-button-push-right {
  margin-left: auto;
}

.rx-form-input,
.rx-form-select,
.rx-form-textarea {
  box-sizing: border-box;
  display: block;
  width: 100%;
  font-weight: normal;
  padding: 8px;
  font-family: var(--rx-font-ui);
  font-size: 15px;
  outline: none;
  border-radius: 4px;
  box-shadow: none;
  line-height: 1.3;
  color: var(--rx-fg-dark-text);
  background: var(--rx-bg-input-shaded);
  border: 1px solid var(--rx-border-input);
}
.rx-form-input:focus,
.rx-form-select:focus,
.rx-form-textarea:focus {
  border-color: var(--rx-border-focus);
  box-shadow: 0 0 0 1px var(--rx-border-focus);
}

.rx-form-textarea {
  resize: vertical;
  line-height: 1.5;
}

.rx-form-select {
  font-size: 15px;
  cursor: pointer;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.65em center;
  padding-right: 28px;
  min-height: 35px;
}

[rx-data-theme=dark] .rx-form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.rx-form-checkbox {
  box-sizing: border-box;
  vertical-align: middle;
  margin: 0 !important;
  margin-right: 4px !important;
}

.rx-form-checkbox-label {
  color: var(--rx-fg-dark-text);
  font-family: var(--rx-font-ui);
  font-size: 15px;
  line-height: 1.4;
}

.rx-form-upload-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  margin-bottom: 10px;
  border: 1px dashed var(--rx-border-dark-medium);
  background: var(--rx-bg-dark-dimmed);
  border-radius: var(--rx-rounded-md);
  min-width: 160px;
  height: 160px;
  cursor: pointer;
  position: relative;
}
.rx-form-upload-box input[type=file] {
  font-size: 13px;
}
.rx-form-upload-box img {
  position: relative;
  z-index: 2;
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.rx-form-upload-box:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.rx-form-upload-box.rx-form-upload-hover {
  border-color: var(--rx-border-dark-medium);
  background-color: var(--rx-bg-dark-subtle);
}
.rx-form-upload-box.rx-form-upload-error {
  border-color: var(--rx-border-negative-medium);
  background-color: var(--rx-bg-negative-minimal);
}

.rx-upload-remove {
  position: absolute;
  z-index: 3;
  top: -6px;
  right: -10px;
  background-color: var(--rx-bg-black-accent);
  color: var(--rx-fg-white-accent);
  opacity: 1;
  width: 20px;
  height: 20px;
  text-align: center;
  border-radius: 10px;
  font-size: 14px;
  line-height: 20px;
}
.rx-upload-remove:after {
  content: "×";
}
.rx-upload-remove:hover {
  background-color: var(--rx-bg-black-accent-hover);
}

.rx-form-upload-cover-off img {
  object-fit: initial;
  height: auto;
  width: auto;
}

.rx-form-upload-placeholder {
  font-family: var(--rx-font-ui);
  color: var(--rx-fg-dark-minimal);
  font-size: 12px;
  line-height: 1.35;
  padding: 0 8px;
  text-align: center;
}
.rx-form-upload-placeholder svg {
  fill: var(--rx-fg-dark-minimal);
}

@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
.rx-editor-progress {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11000;
  width: 100%;
  background-color: var(--rx-bg-dark-subtle);
}
.rx-editor-progress span {
  animation: progress-bar-stripes 2s linear infinite;
  content: "";
  display: block;
  min-height: 8px;
  width: 100%;
  height: 100%;
  background-color: var(--rx-bg-primary-accent);
  background-image: -webkit-linear-gradient(45deg, var(--rx-bg-light-strong) 25%, transparent 25%, transparent 50%, var(--rx-bg-light-strong) 50%, var(--rx-bg-light-strong) 75%, transparent 75%, transparent);
  background-image: linear-gradient(45deg, var(--rx-bg-light-strong) 25%, transparent 25%, transparent 50%, var(--rx-bg-light-strong) 50%, var(--rx-bg-light-strong) 75%, transparent 75%, transparent);
  background-size: 40px 40px;
}

.rx-panel {
  position: absolute;
  min-width: 240px;
  max-height: 300px;
  margin: 0;
  padding: 0;
  z-index: 99;
  font-family: var(--rx-font-ui);
  font-size: 14px;
  overflow: auto;
  border-radius: 4px;
  padding: 4px;
  background: var(--rx-bg-overlay);
  box-shadow: var(--rx-shadow-dropdown);
}

.rx-panel-box {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.rx-panel-title {
  font-family: var(--rx-font-ui);
  font-size: 13px;
  font-weight: 500;
  color: var(--rx-fg-dark-subtle);
}

.rx-panel-box {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.rx-panel-item {
  box-sizing: border-box;
  padding: 4px;
  border-bottom: 1px solid transparent;
}

.rx-panel-item {
  display: flex;
  align-items: center;
  vertical-align: middle;
  gap: 6px;
  border-radius: 8px;
  cursor: pointer;
  padding: 8px;
  line-height: 1;
  text-decoration: none;
  color: var(--rx-fg-dark-accent);
}

.rx-panel-item:hover {
  color: var(--rx-fg-dark-accent);
  background: var(--rx-bg-dark-subtle);
}

.rx-panel-item.active {
  color: var(--rx-fg-dark-accent);
  background: var(--rx-bg-primary-medium);
}

.rx-panel-item-icon {
  min-width: 16px;
}

.rx-panel-item-icon svg {
  width: 16px;
  height: 16px;
  fill: var(--rx-fg-dark-accent);
}

.rx-panel-stack .rx-panel-box {
  flex-direction: column;
}

.rx-ai-main {
  padding: 12px;
  border-radius: 8px;
  background: var(--rx-bg-raised);
  border: 1px solid var(--rx-border-dark-subtle);
}

.rx-ai-footer {
  margin-top: 16px !important;
  display: flex;
  gap: 8px;
}

.rx-ai-buttons {
  margin-left: auto !important;
  display: flex;
  gap: 8px;
}

.rx-ai-preview-label,
.rx-ai-label {
  box-sizing: border-box;
  font-family: var(--rx-font-ui);
  font-size: 13px;
  line-height: 1.4;
  font-weight: 500;
  display: block;
  padding: 0;
  margin: 0;
  padding-bottom: 6px;
  color: var(--rx-fg-dark-subtle);
}

.rx-ai-select,
.rx-ai-size {
  width: auto;
  max-width: 320px;
}

.rx-ai-progress {
  margin-bottom: 12px !important;
}
.rx-ai-progress:empty {
  display: none;
}
.rx-ai-progress svg {
  fill: var(--rx-fg-dark-accent);
}

.rx-ai-preview {
  font-family: var(--rx-font-ui);
  font-weight: normal;
  letter-spacing: normal;
  text-transform: none;
  font-size: 16px;
  line-height: 1.618;
  color: var(--rx-fg-dark-text);
  margin-bottom: 12px !important;
}
.rx-ai-preview:empty {
  display: none;
}

@media only screen and (max-width: 767px) {
  .rx-ai-footer,
  .rx-ai-buttons {
    flex-direction: column;
    width: 100%;
  }
  .rx-ai-select,
  .rx-ai-size {
    max-width: 100%;
  }
  .rx-ai-button {
    justify-content: center;
  }
}
.rx-voice-label {
  display: none;
}

.rx-visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.rx-hidden {
  display: none !important;
}

.rx-code-lang-select {
  position: absolute;
  top: 2px;
  right: 4px;
  z-index: 3;
}

.rx-collapsed {
  position: relative;
}

.rx-collapsed:before {
  content: "›";
  position: absolute;
  left: -12px;
  line-height: 1;
  top: 50%;
  margin-top: -7px;
  font-size: 14px;
}

.rx-toc {
  margin-bottom: 24px;
}

[rx-modal-name=image] .rx-modal-body {
  padding: 16px;
  padding-top: 0;
}

.rx-modal-image-section-or {
  margin: 16px 0;
  font-family: var(--rx-font-ui);
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  font-size: 11px;
  color: var(--rx-fg-dark-subtle);
}

.rx-modal-images-box {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.rx-modal-images-box img {
  vertical-align: top;
  max-width: 100px;
  max-height: 66px;
  height: 100%;
  width: min-content;
  cursor: pointer;
}
.rx-modal-images-box img:hover {
  outline: 3px solid var(--rx-border-focus);
}

.rx-modal-images-box-edit {
  padding-left: 20px;
  padding-right: 20px;
}

.rx-form-item-edit-image-box {
  padding: 20px;
  padding-bottom: 0;
}

.rx-form-item-image {
  margin-right: 8px;
}
.rx-form-item-image img {
  max-height: 160px;
  width: auto;
}

[rx-modal-name=emoji] .rx-modal-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rx-emoji-title {
  font-family: var(--rx-font-ui);
  font-size: 13px;
  font-weight: 500;
  color: var(--rx-fg-dark-subtle);
}

.rx-emoji-box {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.rx-emoji-item {
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  font-size: 24px;
  line-height: 1;
}

.rx-emoji-item:hover {
  background: var(--rx-bg-dark-subtle);
}

.rx-panel-emoji {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rx-panel-emoji .rx-panel-item {
  font-size: 24px;
}

[rx-modal-name=snippets] .rx-modal-body,
[rx-modal-name=templates] .rx-modal-body {
  padding: 20px;
  padding-bottom: 0;
  display: flex;
  flex-wrap: wrap;
}

.rx-snippet-container {
  box-sizing: border-box;
  margin-right: 10px;
  margin-bottom: 20px;
}

.rx-snippet-name {
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 600;
  font-family: var(--rx-font-ui);
  color: var(--rx-fg-dark-text);
  margin-top: 8px;
  padding-right: 10px;
  text-align: left;
  max-width: 100px;
}

.rx-snippet-box {
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: var(--shadow-md-border);
  cursor: pointer;
  border: 1px solid transparent;
  overflow: hidden;
}
.rx-snippet-box:hover {
  border: 1px solid var(--rx-border-primary-accent);
}

.rx-snippet-image,
.rx-template-image {
  min-height: 80px;
  max-height: 80px;
  box-sizing: border-box;
}
.rx-snippet-image img,
.rx-template-image img {
  max-width: 160px;
}

.rx-template-image {
  min-height: 130px;
  max-height: initial;
}
.rx-template-image img {
  max-width: 100px;
}

.rx-snippet-preview,
.rx-template-preview {
  box-sizing: border-box;
  overflow: hidden;
  transform-origin: top left;
  transform: scale(0.25);
  margin-right: -480px;
  margin-bottom: -240px;
  padding: 40px;
  width: 640px;
  height: 320px;
  position: relative;
}
.rx-snippet-preview:before,
.rx-template-preview:before {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: absolute;
  z-index: 1;
}
.rx-snippet-preview:hover,
.rx-template-preview:hover {
  border-color: var(--rx-border-primary-accent);
}
.rx-snippet-preview fieldset, .rx-snippet-preview iframe, .rx-snippet-preview img,
.rx-template-preview fieldset,
.rx-template-preview iframe,
.rx-template-preview img {
  border: 0;
}
.rx-snippet-preview embed, .rx-snippet-preview object, .rx-snippet-preview audio, .rx-snippet-preview img, .rx-snippet-preview video,
.rx-template-preview embed,
.rx-template-preview object,
.rx-template-preview audio,
.rx-template-preview img,
.rx-template-preview video {
  max-width: 100%;
  height: auto;
}
.rx-snippet-preview h1:empty,
.rx-snippet-preview h2:empty,
.rx-snippet-preview h3:empty,
.rx-snippet-preview h4:empty,
.rx-snippet-preview h5:empty,
.rx-snippet-preview h6:empty,
.rx-snippet-preview p:empty,
.rx-snippet-preview div:empty,
.rx-template-preview h1:empty,
.rx-template-preview h2:empty,
.rx-template-preview h3:empty,
.rx-template-preview h4:empty,
.rx-template-preview h5:empty,
.rx-template-preview h6:empty,
.rx-template-preview p:empty,
.rx-template-preview div:empty {
  background-color: var(--rx-border-primary-subtle);
  min-height: 1.5em;
}

.rx-template-preview {
  transform: scale(0.25);
  margin-right: -300px;
  margin-bottom: -390px;
  padding: 40px;
  width: 400px;
  height: 520px;
}

.rx-empty h1:empty,
.rx-empty h2:empty,
.rx-empty h3:empty,
.rx-empty h4:empty,
.rx-empty h5:empty,
.rx-empty h6:empty,
.rx-empty p:empty,
.rx-empty li:empty,
.rx-empty dt:empty,
.rx-empty dd:empty,
.rx-empty address:empty,
.rx-empty figcaption:empty,
.rx-empty blockquote:empty {
  min-height: 1.5em;
}
.rx-empty pre:empty {
  min-height: 3.5em;
}
.rx-empty strong:empty, .rx-empty b:empty, .rx-empty em:empty, .rx-empty i:empty, .rx-empty span:empty, .rx-empty sup:empty, .rx-empty sub:empty, .rx-empty u:empty, .rx-empty ins:empty, .rx-empty code:empty, .rx-empty del:empty, .rx-empty cite:empty {
  display: inline-block;
  min-width: 1px;
  min-height: 1em;
}
.rx-empty th:empty:after, .rx-empty td:empty:after {
  content: "​";
}
.rx-empty code:after, .rx-empty kbd:after, .rx-empty mark:after {
  content: "​";
}
.rx-empty pre code:after {
  display: none;
}
.rx-empty code + code {
  margin-left: 2px;
}
.rx-empty table {
  empty-cells: show;
}
.rx-empty embed, .rx-empty img, .rx-empty object {
  max-width: 100%;
  height: auto;
}

.rx-content {
  text-align: left;
  --rx-font-text: -apple-system, BlinkMacSystemFont, "San Francisco", "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
  --rx-font-heading: inherit;
  --rx-font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --rx-body-color: var(--rx-bg-body);
  --rx-heading-color: var(--rx-fg-heading);
  --rx-text-color: var(--rx-fg-text);
  --rx-table-border: var(--rx-border-dark-minimal);
  --rx-line-color: var(--rx-border-dark-minimal);
  --rx-pre-color: var(--rx-fg-text);
  --rx-pre-bg: var(--rx-bg-dark-minimal);
  --rx-var-color: var(--rx-fg-text);
  --rx-kbd-color: var(--rx-fg-text);
  --rx-kbd-border: var(--rx-border-dark-subtle);
  --rx-kbd-bg: var(--rx-bg-light-accent);
  --rx-code-color: var(--rx-fg-text);
  --rx-code-bg: var(--rx-bg-dark-medium);
  --rx-abbr-border: var(--rx-border-dark-accent);
  --rx-quote-border-color: var(--rx-border-dark-accent);
  background: var(--rx-body-color);
  font-family: var(--rx-font-text);
  color: var(--rx-text-color);
  font-size: 16px;
  line-height: 1.5;
}
.rx-content[dir=rtl] {
  text-align: right;
}
.rx-content * {
  margin: 0;
}
.rx-content p, .rx-content li, .rx-content dt, .rx-content dd, .rx-content address {
  font-size: 16px;
  line-height: 1.5;
}
.rx-content h1 + *, .rx-content h2 + *, .rx-content h3 + *, .rx-content h4 + *, .rx-content h5 + *, .rx-content h6 + * {
  margin-top: 12px;
}
.rx-content p + h2, .rx-content p + h3, .rx-content p + h4, .rx-content p + h5, .rx-content p + h6, .rx-content ul + h2, .rx-content ul + h3, .rx-content ul + h4, .rx-content ul + h5, .rx-content ul + h6, .rx-content ol + h2, .rx-content ol + h3, .rx-content ol + h4, .rx-content ol + h5, .rx-content ol + h6, .rx-content pre + h2, .rx-content pre + h3, .rx-content pre + h4, .rx-content pre + h5, .rx-content pre + h6, .rx-content dl + h2, .rx-content dl + h3, .rx-content dl + h4, .rx-content dl + h5, .rx-content dl + h6, .rx-content address + h2, .rx-content address + h3, .rx-content address + h4, .rx-content address + h5, .rx-content address + h6 {
  margin-top: 24px;
}
.rx-content p + *, .rx-content ul + *, .rx-content ol + *, .rx-content pre + *, .rx-content dl + *, .rx-content address + * {
  margin-top: 24px;
}
.rx-content table + *,
.rx-content blockquote + *,
.rx-content figure + *, .rx-content > div + * {
  margin-top: 24px;
}
.rx-content h1 + h2,
.rx-content h2 + h3,
.rx-content h3 + h4,
.rx-content h4 + h5,
.rx-content h5 + h6 {
  margin-top: 12px;
}
.rx-content a,
.rx-content a:hover,
.rx-content a:focus,
.rx-content a:visited {
  color: var(--rx-link-color);
}
.rx-content h1,
.rx-content h2,
.rx-content h3,
.rx-content h4,
.rx-content h5,
.rx-content h6 {
  font-family: var(--rx-font-heading);
  font-weight: bold;
  font-style: normal;
  color: var(--rx-heading-color);
  text-rendering: optimizeLegibility;
  letter-spacing: 0;
}
.rx-content h1 a,
.rx-content h2 a,
.rx-content h3 a,
.rx-content h4 a,
.rx-content h5 a,
.rx-content h6 a {
  text-decoration: underline;
}
.rx-content h1 {
  font-weight: 800;
  letter-spacing: -0.02em;
}
.rx-content h2 {
  font-weight: 700;
  letter-spacing: -0.02em;
}
.rx-content h3,
.rx-content h4,
.rx-content h5,
.rx-content h6 {
  font-weight: 600;
  letter-spacing: -0.01em;
}
.rx-content h1 {
  font-size: 36px;
  line-height: 1.25;
}
.rx-content h2 {
  font-size: 24px;
  line-height: 1.25;
}
.rx-content h3 {
  font-size: 20px;
  line-height: 1.25;
}
.rx-content h4 {
  font-size: 16px;
  line-height: 1.25;
}
.rx-content h5 {
  font-size: 16px;
  line-height: 1.25;
}
.rx-content h6 {
  font-size: 16px;
  line-height: 1.25;
}
.rx-content dfn,
.rx-content abbr {
  font-size: 95%;
}
.rx-content cite,
.rx-content small,
.rx-content var,
.rx-content kbd,
.rx-content code {
  font-size: 85%;
}
.rx-content sup,
.rx-content sub {
  font-size: 65%;
}
.rx-content var,
.rx-content code,
.rx-content kbd {
  display: inline-block;
  font-family: var(--rx-font-mono);
  font-style: normal;
  line-height: 1;
  vertical-align: baseline;
}
.rx-content kbd,
.rx-content code {
  border-radius: 4px;
}
.rx-content kbd {
  color: var(--rx-kbd-color);
  background: var(--rx-kbd-bg);
  border: 1px solid var(--rx-kbd-border);
  padding: 0.2em 0.4em;
}
.rx-content var {
  color: var(--rx-var-color);
}
.rx-content code {
  position: relative;
  top: -1px;
  padding: 0.2em 0.4em 0.2em;
  color: var(--rx-code-color);
  background: var(--rx-code-bg);
  border: 1px solid var(--rx-code-border);
}
.rx-content mark {
  background-color: #FFEA80;
  color: black;
}
.rx-content b,
.rx-content strong {
  font-weight: bold;
}
.rx-content dfn,
.rx-content abbr[title] {
  letter-spacing: 0.01em;
  text-transform: uppercase;
  text-decoration: none;
  border-bottom: 1px dotted var(--rx-abbr-border);
  cursor: help;
}
.rx-content cite {
  color: var(--rx-cite-color, var(--rx-text-color));
  font-style: italic;
}
.rx-content sub,
.rx-content sup {
  line-height: 1;
  margin-left: 2px;
}
.rx-content sub {
  vertical-align: sub;
}
.rx-content sup {
  vertical-align: super;
}
.rx-content ul {
  list-style: disc;
}
.rx-content ol {
  list-style: decimal;
}
.rx-content ol > li > ol {
  list-style-type: lower-alpha;
}
.rx-content ol > li > ol > li > ol {
  list-style-type: lower-roman;
}
.rx-content ul,
.rx-content ol {
  padding-left: 0;
  margin-left: 20px;
}
.rx-content li li {
  font-size: 1em;
}
.rx-content dt {
  font-weight: bold;
}
.rx-content dd + dt {
  margin-top: 0.25em;
}
.rx-content pre {
  overflow: auto;
  white-space: pre;
  font-family: var(--rx-font-mono);
  font-size: 14px;
  line-height: 1.6;
  padding: 1em;
  border-radius: 3px;
  border: 1px solid var(--rx-pre-border, transparent);
  background: var(--rx-pre-bg, transparent);
  color: var(--rx-pre-color, var(--rx-text-color));
}
.rx-content pre code {
  position: initial;
  color: inherit;
  white-space: pre;
  padding: 0;
  border: 0;
  font-size: 100%;
  display: block;
  line-height: inherit;
  background: none;
}
.rx-content blockquote,
.rx-content figure:has(blockquote) {
  padding: 0;
  background: var(--rx-quote-bg, transparent);
  padding-left: 24px;
  border-left: var(--rx-quote-border-width, 3px) solid var(--rx-quote-border-color);
}
.rx-content blockquote p,
.rx-content figure:has(blockquote) p {
  font-style: italic;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.4;
  color: var(--rx-quote-color, var(--rx-text-color));
}
.rx-content blockquote p + p,
.rx-content figure:has(blockquote) p + p {
  margin-top: 0.5em;
}
.rx-content figure:has(blockquote) blockquote {
  padding: 0;
  border: none;
  box-shadow: none;
  background: transparent;
  border-radius: 0;
}
.rx-content blockquote cite,
.rx-content figcaption cite {
  font-style: italic;
  font-weight: normal;
  color: var(--rx-quote-caption-color, var(--rx-text-color));
  font-size: 14px;
  line-height: 1.3;
}
.rx-content caption {
  text-align: left;
  font-style: normal;
}
.rx-content table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  empty-cells: show;
  font-size: 15px;
  line-height: 1.5;
  color: var(--rx-table-color, var(--rx-text-color));
}
.rx-content td,
.rx-content th {
  text-align: left;
  vertical-align: top;
  padding: 0.75em;
  border: 1px solid var(--rx-table-border);
}
.rx-content th {
  font-weight: normal;
}
.rx-content thead th {
  font-weight: bold;
}
.rx-content address {
  font-style: italic;
}
.rx-content figcaption {
  display: block;
  margin-top: 4px;
  font-size: 14px;
  line-height: 1.3;
  background: var(--rx-caption-bg, transparent);
  color: var(--rx-caption-color, var(--rx-text-color));
}
.rx-content figure > img, .rx-content figure > img a, .rx-content figure > iframe, .rx-content figure > pre, .rx-content figure > div {
  vertical-align: middle;
}
.rx-content .embed-responsive:has(iframe) {
  position: relative;
  padding: 0;
  padding-bottom: 56.25%;
  height: 0;
}
.rx-content .embed-responsive:has(iframe) iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.rx-content div.embed-responsive {
  margin: 0;
}
.rx-content hr {
  --rx-line-size: 1px;
  --rx-line-width: 100%;
  --rx-line-style: solid;
  position: relative;
  line-height: 1;
  background: none;
  border: none !important;
  text-align: left;
  padding-top: 1.5em;
  padding-bottom: 1.5em;
  margin: 0 !important;
  opacity: 1;
  width: auto;
}
.rx-content hr:after {
  content: "";
  position: absolute;
  top: 50%;
  width: var(--rx-line-width);
  max-width: var(--rx-line-width);
  margin-top: -calc(var(--rx-line-size)/2);
  border-top-width: var(--rx-line-size);
  border-top-style: var(--rx-line-style);
  border-top-color: var(--rx-line-color);
}
.rx-content .wrap-center {
  text-align: center;
}
.rx-content .wrap-center img {
  margin-left: auto;
  margin-right: auto;
}
.rx-content .wrap-center figcaption {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.rx-content .float-left {
  float: left;
  margin-right: 1em;
  margin-bottom: 1em;
  max-width: 200px;
}
.rx-content .float-right {
  float: right;
  margin-left: 1em;
  margin-bottom: 1em;
  max-width: 200px;
}
.rx-content .outset-right {
  position: relative;
  width: calc(100% + var(--rx-outset-md));
  max-width: calc(100% + var(--rx-outset-md));
  transform: translateX(var(--rx-outset-md)) translate3d(0, 0, 0);
  left: calc(var(--rx-outset-md) * -1);
}
.rx-content .outset-left {
  width: calc(100% + var(--rx-outset-md));
  max-width: calc(100% + var(--rx-outset-md));
  transform: translateX(calc(var(--rx-outset-md) * -1)) translate3d(0, 0, 0);
}
.rx-content .outset-both {
  position: relative;
  width: calc(100% + var(--rx-outset-md) + var(--rx-outset-md));
  max-width: calc(100% + var(--rx-outset-md) + var(--rx-outset-md));
  transform: translateX(-50%) translate3d(0, 0, 0);
  left: 50%;
}

.rx-editor-wym h1,
.rx-editor-wym h2,
.rx-editor-wym h3,
.rx-editor-wym h4,
.rx-editor-wym h5,
.rx-editor-wym h6,
.rx-editor-wym ul:not([data-structure=false]),
.rx-editor-wym ol:not([data-structure=false]),
.rx-editor-wym dl,
.rx-editor-wym address,
.rx-editor-wym p {
  position: relative;
  background: var(--rx-bg-base);
  padding: 8px 12px;
}
.rx-editor-wym h1:after,
.rx-editor-wym h2:after,
.rx-editor-wym h3:after,
.rx-editor-wym h4:after,
.rx-editor-wym h5:after,
.rx-editor-wym h6:after,
.rx-editor-wym ul:not([data-structure=false]):after,
.rx-editor-wym ol:not([data-structure=false]):after,
.rx-editor-wym dl:after,
.rx-editor-wym address:after,
.rx-editor-wym p:after {
  position: absolute;
  font-size: 11px;
  font-weight: normal;
  top: 2px;
  right: 4px;
  cursor: pointer;
  color: var(--rx-fg-placeholder);
}
.rx-editor-wym h1:empty::before,
.rx-editor-wym h2:empty::before,
.rx-editor-wym h3:empty::before,
.rx-editor-wym h4:empty::before,
.rx-editor-wym h5:empty::before,
.rx-editor-wym h6:empty::before,
.rx-editor-wym ul:not([data-structure=false]):empty::before,
.rx-editor-wym ol:not([data-structure=false]):empty::before,
.rx-editor-wym dl:empty::before,
.rx-editor-wym address:empty::before,
.rx-editor-wym p:empty::before {
  content: "​";
  display: inline-block;
}
.rx-editor-wym pre {
  position: relative;
}
.rx-editor-wym pre:after {
  position: absolute;
  font-size: 11px;
  font-weight: normal;
  top: 2px;
  right: 4px;
  cursor: pointer;
  color: var(--rx-fg-placeholder);
}
.rx-editor-wym ul:not([data-structure=false]) ul,
.rx-editor-wym ol:not([data-structure=false]) ol {
  outline: 1px solid var(--rx-border-divider) !important;
}
.rx-editor-wym ul:not([data-rx-type=todo]),
.rx-editor-wym ol {
  margin-left: 0;
  padding-left: 24px;
  margin-bottom: 3px;
}
.rx-editor-wym ol:not([data-structure=false]):after {
  content: "ol";
}
.rx-editor-wym ul:not([data-structure=false]):after {
  content: "ul";
}
.rx-editor-wym dl:after {
  content: "dl";
}
.rx-editor-wym h1:after {
  content: "h1";
}
.rx-editor-wym h2:after {
  content: "h2";
}
.rx-editor-wym h3:after {
  content: "h3";
}
.rx-editor-wym h4:after {
  content: "h4";
}
.rx-editor-wym h5:after {
  content: "h5";
}
.rx-editor-wym h6:after {
  content: "h6";
}
.rx-editor-wym p:after {
  content: "p";
}
.rx-editor-wym pre:after {
  content: "pre";
}
.rx-editor-wym address:after {
  content: "address";
}`, "",{"version":3,"sources":["webpack://./app/javascript/admin/redactor/redactor.css"],"names":[],"mappings":"AAAA;EACE,kHAAkH;EAClH,qHAAqH;EACrH,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB,sCAAsC;EACtC,2CAA2C;EAC3C,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,0CAA0C;EAC1C,iDAAiD;EACjD,wBAAwB;EACxB,+BAA+B;EAC/B,uBAAuB;EACvB,uCAAuC;EACvC,qCAAqC;EACrC,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,qCAAqC;EACrC,uCAAuC;EACvC,wCAAwC;EACxC,uCAAuC;EACvC,wCAAwC;EACxC,yCAAyC;EACzC,wCAAwC;EACxC,wCAAwC;EACxC,wCAAwC;EACxC,4BAA4B;EAC5B,6CAA6C;EAC7C,4CAA4C;EAC5C,6CAA6C;EAC7C,2CAA2C;EAC3C,2CAA2C;EAC3C,gCAAgC;EAChC,6BAA6B;EAC7B,8BAA8B;EAC9B,4CAA4C;EAC5C,8CAA8C;EAC9C,+CAA+C;EAC/C,8CAA8C;EAC9C,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,+CAA+C;EAC/C,+CAA+C;EAC/C,6BAA6B;EAC7B,oDAAoD;EACpD,mDAAmD;EACnD,oDAAoD;EACpD,kDAAkD;EAClD,kDAAkD;EAClD,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,yCAAyC;EACzC,6BAA6B;EAC7B,8CAA8C;EAC9C,6CAA6C;EAC7C,8CAA8C;EAC9C,4CAA4C;EAC5C,4CAA4C;EAC5C,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,4CAA4C;EAC5C,8CAA8C;EAC9C,+CAA+C;EAC/C,8CAA8C;EAC9C,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,+CAA+C;EAC/C,6BAA6B;EAC7B,oDAAoD;EACpD,mDAAmD;EACnD,oDAAoD;EACpD,kDAAkD;EAClD,kDAAkD;EAClD,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;EACpC,oCAAoC;EACpC,qCAAqC;EACrC,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,8CAA8C;EAC9C,+CAA+C;EAC/C,0CAA0C;EAC1C,iLAAiL;EACjL,2HAA2H;EAC3H,wFAAwF;EACxF,mDAAmD;EACnD,sDAAsD;EACtD,6CAA6C;EAC7C,4IAA4I;EAC5I,iJAAiJ;EACjJ,iFAAiF;EACjF,gLAAgL;EAChL,qLAAqL;AACvL;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EACzB,2CAA2C;EAC3C,iDAAiD;EACjD,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,uCAAuC;EACvC,8CAA8C;EAC9C,+BAA+B;EAC/B,6CAA6C;EAC7C,2CAA2C;EAC3C,0BAA0B;EAC1B,4BAA4B;EAC5B,8CAA8C;EAC9C,2CAA2C;EAC3C,6CAA6C;EAC7C,8CAA8C;EAC9C,6CAA6C;EAC7C,8CAA8C;EAC9C,+CAA+C;EAC/C,8CAA8C;EAC9C,8CAA8C;EAC9C,8CAA8C;EAC9C,4BAA4B;EAC5B,mDAAmD;EACnD,kDAAkD;EAClD,mDAAmD;EACnD,iDAAiD;EACjD,iDAAiD;EACjD,gCAAgC;EAChC,6BAA6B;EAC7B,yCAAyC;EACzC,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;EAC1C,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,6BAA6B;EAC7B,8CAA8C;EAC9C,6CAA6C;EAC7C,8CAA8C;EAC9C,4CAA4C;EAC5C,4CAA4C;EAC5C,iCAAiC;EACjC,+BAA+B;EAC/B,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,oCAAoC;EACpC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,gCAAgC;EAChC,gCAAgC;EAChC,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;EAChC,gCAAgC;EAChC,gCAAgC;EAChC,sCAAsC;EACtC,gCAAgC;EAChC,qCAAqC;EACrC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,oDAAoD;EACpD,qDAAqD;EACrD,0CAA0C;EAC1C,sLAAsL;EACtL,gIAAgI;EAChI,sFAAsF;EACtF,qLAAqL;EACrL,0LAA0L;AAC5L;;AAEA;EACE;IACE,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;;EAEE,wBAAwB;AAC1B;AACA;;;;;EAKE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,oDAAoD;EACpD,mBAAmB;AACrB;AACA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gDAAgD;AAClD;AACA;EACE,aAAa;AACf;AACA;EACE,gDAAgD;AAClD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,oBAAoB;EACpB,+CAA+C;EAC/C,8CAA8C;EAC9C,gCAAgC;EAChC,4DAA4D;EAC5D,8CAA8C;EAC9C,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,0BAA0B;EAC1B,2BAA2B;EAC3B,6CAA6C;EAC7C,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sCAAsC;EACtC,uCAAuC;EACvC,6BAA6B;EAC7B,uDAAuD;AACzD;AACA;EACE,iDAAiD;EACjD,2CAA2C;EAC3C,yCAAyC;AAC3C;AACA;EACE,uDAAuD;EACvD,qDAAqD;AACvD;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,uCAAuC;EACvC,iDAAiD;EACjD,kBAAkB;AACpB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,+BAA+B;EAC/B,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,2CAA2C;EAC3C,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,uBAAuB;EACvB,qCAAqC;EACrC,uCAAuC;AACzC;AACA;;EAEE,qCAAqC;EACrC,yCAAyC;EACzC,uCAAuC;AACzC;AACA;;EAEE,kCAAkC;EAClC,mCAAmC;AACrC;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,qDAAqD;AACvD;AACA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;;EAEE,+BAA+B;EAC/B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gCAAgC;EAChC,gCAAgC;EAChC,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,gCAAgC;EAChC,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,QAAQ;EACR,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;EACnC,WAAW;EACX,cAAc;EACd,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,MAAM;EACN,OAAO;EACP,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,8BAA8B;EAC9B,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,8CAA8C;EAC9C,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,mCAAmC;EACnC,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,qCAAqC;EACrC,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;EAChC,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;EACE,+BAA+B;AACjC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;EACnC,sCAAsC;EACtC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,8CAA8C;EAC9C,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;EACV,8CAA8C;EAC9C,mBAAmB;EACnB,oBAAoB;EACpB,MAAM;AACR;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;AACA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,8CAA8C;AAChD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,0CAA0C;AAC5C;AACA;EACE,kDAAkD;EAClD,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,wCAAwC;AAC1C;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;;;EAGE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,yDAAkhB;EAClhB,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yDAAyhB;AAC3hB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,+CAA+C;EAC/C,oCAAoC;EACpC,mCAAmC;EACnC,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;AACA;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,2CAA2C;EAC3C,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,cAAc;EACd,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,kDAAkD;EAClD,WAAW;EACX,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,6CAA6C;EAC7C,6MAA6M;EAC7M,qMAAqM;EACrM,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,sBAAsB;IACtB,WAAW;EACb;EACA;;IAEE,eAAe;EACjB;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;;EAEE,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,6CAA6C;AAC/C;AACA;;;;EAIE,SAAS;AACX;AACA;;;;;;EAME,eAAe;EACf,YAAY;AACd;AACA;;;;;;;;;;;;;;;;EAgBE,iDAAiD;EACjD,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;;;;;;;;;;;;;EAaE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,oHAAoH;EACpH,0BAA0B;EAC1B,kHAAkH;EAClH,kCAAkC;EAClC,wCAAwC;EACxC,kCAAkC;EAClC,gDAAgD;EAChD,8CAA8C;EAC9C,iCAAiC;EACjC,sCAAsC;EACtC,iCAAiC;EACjC,iCAAiC;EACjC,6CAA6C;EAC7C,sCAAsC;EACtC,kCAAkC;EAClC,sCAAsC;EACtC,8CAA8C;EAC9C,qDAAqD;EACrD,gCAAgC;EAChC,gCAAgC;EAChC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;AAClB;AACA;;;;;EAKE,gBAAgB;AAClB;AACA;;;;EAIE,2BAA2B;AAC7B;AACA;;;;;;EAME,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;EAClC,iBAAiB;AACnB;AACA;;;;;;EAME,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;;EAIE,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;;;EAGE,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,wBAAwB;AAC1B;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,sCAAsC;EACtC,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;EAC1B,2BAA2B;EAC3B,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,+CAA+C;EAC/C,YAAY;AACd;AACA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mDAAmD;EACnD,yCAAyC;EACzC,gDAAgD;AAClD;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,iFAAiF;AACnF;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kDAAkD;AACpD;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kDAAkD;AACpD;AACA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6CAA6C;EAC7C,oDAAoD;AACtD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,UAAU;EACV,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,+BAA+B;EAC/B,wCAAwC;EACxC,qCAAqC;EACrC,sCAAsC;EACtC,sCAAsC;AACxC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,2CAA2C;EAC3C,+DAA+D;EAC/D,oCAAoC;AACtC;AACA;EACE,uCAAuC;EACvC,2CAA2C;EAC3C,0EAA0E;AAC5E;AACA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,iEAAiE;EACjE,gDAAgD;EAChD,SAAS;AACX;;AAEA;;;;;;;;;;;EAWE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;;;;;;;;;;;EAWE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,+BAA+B;AACjC;AACA;;;;;;;;;;;EAWE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,+BAA+B;AACjC;AACA;;EAEE,sDAAsD;AACxD;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[":root {\n  --rx-font-ui: -apple-system, BlinkMacSystemFont, \"San Francisco\", \"Segoe UI\", Roboto, \"Helvetica Neue\", sans-serif;\n  --rx-font-ui-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --rx-rounded-sm: 3px;\n  --rx-rounded-md: 6px;\n  --rx-rounded-lg: 9px;\n  --rx-rounded-xl: 12px;\n  --rx-rounded-circle: 99px;\n  --rx-level-control: 3;\n  --rx-level-toolbar: 5;\n  --rx-level-tooltip: 99;\n  --rx-level-popup: 100;\n  --rx-outset-md: 28px;\n  --rx-toolbar-height: 36px;\n  --rx-toolbar-padding: 2px;\n  --rx-toolbar-button-width: 34px;\n  --rx-toolbar-button-height: 34px;\n  --rx-toolbar-icon-size: 20px;\n  --rx-fg-heading: #070707;\n  --rx-fg-text: #2B2B3A;\n  --rx-fg-subtle: #63636E;\n  --rx-fg-placeholder: #73737C;\n  --rx-bg-input: #FFFFFF;\n  --rx-bg-input-shaded: #F7F7F8;\n  --rx-bg-input-on: #070707;\n  --rx-bg-input-off: rgba(7, 7, 7, 0.15);\n  --rx-bg-input-disabled: rgba(7, 7, 7, 0.05);\n  --rx-bg-aluminum: #f8f8f8;\n  --rx-bg-silver: #E6E6E6;\n  --rx-bg-platinum: #CDCDCD;\n  --rx-bg-base: #FFFFFF;\n  --rx-bg-raised: #FFFFFF;\n  --rx-bg-overlay: #FFFFFF;\n  --rx-bg-toolbar: rgba(255, 255, 255, 0.97);\n  --rx-bg-toolbar-raised: rgba(255, 255, 255, 0.97);\n  --rx-bg-context: #070707;\n  --rx-bg-context-active: #042C6A;\n  --rx-bg-source: #191919;\n  --rx-border-divider: rgba(7, 7, 7, 0.1);\n  --rx-border-input: rgba(7, 7, 7, 0.2);\n  --rx-border-focus: #73A9FF;\n  --rx-fg-dark-accent: #070707;\n  --rx-fg-dark-heading: #070707;\n  --rx-fg-dark-text: rgba(7, 7, 7, 0.8);\n  --rx-fg-dark-subtle: rgba(7, 7, 7, 0.6);\n  --rx-fg-dark-minimal: rgba(7, 7, 7, 0.5);\n  --rx-fg-dark-dimmed: rgba(7, 7, 7, 0.4);\n  --rx-bg-dark-dimmed: rgba(7, 7, 7, 0.03);\n  --rx-bg-dark-minimal: rgba(7, 7, 7, 0.05);\n  --rx-bg-dark-subtle: rgba(7, 7, 7, 0.08);\n  --rx-bg-dark-medium: rgba(7, 7, 7, 0.15);\n  --rx-bg-dark-strong: rgba(7, 7, 7, 0.25);\n  --rx-bg-dark-accent: #070707;\n  --rx-bg-dark-accent-hover: rgba(7, 7, 7, 0.8);\n  --rx-border-dark-dimmed: rgba(7, 7, 7, 0.05);\n  --rx-border-dark-minimal: rgba(7, 7, 7, 0.08);\n  --rx-border-dark-subtle: rgba(7, 7, 7, 0.1);\n  --rx-border-dark-medium: rgba(7, 7, 7, 0.2);\n  --rx-border-dark-accent: #070707;\n  --rx-fg-light-accent: #FFFFFF;\n  --rx-fg-light-heading: #FFFFFF;\n  --rx-fg-light-text: rgba(255, 255, 255, 0.8);\n  --rx-fg-light-subtle: rgba(255, 255, 255, 0.6);\n  --rx-fg-light-minimal: rgba(255, 255, 255, 0.5);\n  --rx-fg-light-dimmed: rgba(255, 255, 255, 0.4);\n  --rx-bg-light-dimmed: rgba(255, 255, 255, 0.03);\n  --rx-bg-light-minimal: rgba(255, 255, 255, 0.05);\n  --rx-bg-light-subtle: rgba(255, 255, 255, 0.08);\n  --rx-bg-light-medium: rgba(255, 255, 255, 0.15);\n  --rx-bg-light-strong: rgba(255, 255, 255, 0.25);\n  --rx-bg-light-accent: #FFFFFF;\n  --rx-bg-light-accent-hover: rgba(255, 255, 255, 0.8);\n  --rx-border-light-dimmed: rgba(255, 255, 255, 0.05);\n  --rx-border-light-minimal: rgba(255, 255, 255, 0.08);\n  --rx-border-light-subtle: rgba(255, 255, 255, 0.1);\n  --rx-border-light-medium: rgba(255, 255, 255, 0.2);\n  --rx-border-light-accent: #FFFFFF;\n  --rx-fg-black-accent: #070707;\n  --rx-fg-black-heading: #070707;\n  --rx-fg-black-text: rgba(7, 7, 7, 0.8);\n  --rx-fg-black-subtle: rgba(7, 7, 7, 0.6);\n  --rx-fg-black-minimal: rgba(7, 7, 7, 0.5);\n  --rx-fg-black-dimmed: rgba(7, 7, 7, 0.4);\n  --rx-bg-black-dimmed: rgba(7, 7, 7, 0.03);\n  --rx-bg-black-minimal: rgba(7, 7, 7, 0.05);\n  --rx-bg-black-subtle: rgba(7, 7, 7, 0.08);\n  --rx-bg-black-medium: rgba(7, 7, 7, 0.15);\n  --rx-bg-black-accent: #070707;\n  --rx-bg-black-accent-hover: rgba(7, 7, 7, 0.8);\n  --rx-border-black-dimmed: rgba(7, 7, 7, 0.05);\n  --rx-border-black-minimal: rgba(7, 7, 7, 0.08);\n  --rx-border-black-subtle: rgba(7, 7, 7, 0.1);\n  --rx-border-black-medium: rgba(7, 7, 7, 0.2);\n  --rx-border-black-accent: #070707;\n  --rx-fg-white-accent: #FFFFFF;\n  --rx-fg-white-heading: #FFFFFF;\n  --rx-fg-white-text: rgba(255, 255, 255, 0.8);\n  --rx-fg-white-subtle: rgba(255, 255, 255, 0.6);\n  --rx-fg-white-minimal: rgba(255, 255, 255, 0.5);\n  --rx-fg-white-dimmed: rgba(255, 255, 255, 0.4);\n  --rx-bg-white-dimmed: rgba(255, 255, 255, 0.03);\n  --rx-bg-white-minimal: rgba(255, 255, 255, 0.05);\n  --rx-bg-white-subtle: rgba(255, 255, 255, 0.08);\n  --rx-bg-white-medium: rgba(255, 255, 255, 0.15);\n  --rx-bg-white-accent: #FFFFFF;\n  --rx-bg-white-accent-hover: rgba(255, 255, 255, 0.8);\n  --rx-border-white-dimmed: rgba(255, 255, 255, 0.05);\n  --rx-border-white-minimal: rgba(255, 255, 255, 0.08);\n  --rx-border-white-subtle: rgba(255, 255, 255, 0.1);\n  --rx-border-white-medium: rgba(255, 255, 255, 0.2);\n  --rx-border-white-accent: #FFFFFF;\n  --rx-fg-primary-accent: #0063FF;\n  --rx-fg-primary-strong: #0247B5;\n  --rx-fg-primary-text: #043583;\n  --rx-bg-primary-minimal: #F2F7FF;\n  --rx-bg-primary-subtle: #E5EFFF;\n  --rx-bg-primary-medium: #C9DEFF;\n  --rx-bg-primary-accent: #0063FF;\n  --rx-bg-primary-accent-hover: #0247B5;\n  --rx-bg-primary-static: #0063FF;\n  --rx-border-primary-minimal: #C9DEFF;\n  --rx-border-primary-subtle: #99C1FF;\n  --rx-border-primary-medium: #99C1FF;\n  --rx-border-primary-accent: #0063FF;\n  --rx-border-primary-static: #0063FF;\n  --rx-fg-negative-accent: #D70015;\n  --rx-fg-negative-strong: #990211;\n  --rx-fg-negative-text: #6F040E;\n  --rx-bg-negative-minimal: #FFF0F1;\n  --rx-bg-negative-subtle: #FFE1E5;\n  --rx-bg-negative-medium: #FFC1C8;\n  --rx-bg-negative-accent: #D70015;\n  --rx-bg-negative-accent-hover: #D70015;\n  --rx-bg-negative-static: #D70015;\n  --rx-border-negative-minimal: #FFC1C8;\n  --rx-border-negative-subtle: #FF8994;\n  --rx-border-negative-medium: #FF8994;\n  --rx-border-negative-acccent: #D70015;\n  --rx-border-negative-static: #D70015;\n  --rx-link-color: #0063FF;\n  --rx-link-hover-color: #070707;\n  --rx-link-dark-color: #070707;\n  --rx-link-dark-hover-color: rgba(7, 7, 7, 0.6);\n  --rx-link-dark-subtle-color: rgba(7, 7, 7, 0.6);\n  --rx-link-dark-subtle-hover-color: #070707;\n  --rx-shadow-modal: 0 0 1px rgba(7, 7, 7, 0.25), 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);\n  --rx-shadow-dropdown: 0 0 1px rgba(7, 7, 7, 0.25), 0 20px 24px -4px rgba(7, 7, 7, 0.08), 0 8px 8px -4px rgba(7, 7, 7, 0.04);\n  --rx-shadow-toolbar-raised: 0 1px 3px rgba(7, 7, 7, 0.15), 0 1px 2px rgba(7, 7, 7, 0.06);\n  --rx-shadow-reorder: 0 15px 30px rgba(7, 7, 7, 0.3);\n  --rx-shadow-inner: inset 0 1px 1px rgba(7, 7, 7, 0.15);\n  --rx-shadow-sm: 0 1px 3px rgba(7, 7, 7, 0.15);\n  --rx-shadow-md: 0 1px 2px rgba(7, 7, 7, 0.05), 0 3px 6px rgba(7, 7, 7, 0.05), 0 2px 4px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05);\n  --rx-shadow-lg: 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);\n  --rx-shadow-sm-border: 0 0 1px rgba(7, 7, 7, 0.25), 0 1px 3px rgba(7, 7, 7, 0.15);\n  --rx-shadow-md-border: 0 0 1px rgba(7, 7, 7, 0.25), 0 1px 2px rgba(7, 7, 7, 0.05), 0 3px 6px rgba(7, 7, 7, 0.05), 0 2px 4px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05);\n  --rx-shadow-lg-border: 0 0 1px rgba(7, 7, 7, 0.25), 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);\n}\n\n[rx-data-theme=dark] {\n  --rx-fg-heading: #D8D8DB;\n  --rx-fg-text: #C8C8CC;\n  --rx-fg-subtle: #73737C;\n  --rx-fg-placeholder: #73737C;\n  --rx-bg-input: #141414;\n  --rx-bg-input-shaded: #141414;\n  --rx-bg-input-on: #73A9FF;\n  --rx-bg-input-off: rgba(255, 255, 255, 0.2);\n  --rx-bg-input-disabled: rgba(255, 255, 255, 0.05);\n  --rx-bg-aluminum: #191919;\n  --rx-bg-silver: #1E1E1E;\n  --rx-bg-platinum: #2F2F2F;\n  --rx-bg-base: #141414;\n  --rx-bg-raised: #191919;\n  --rx-bg-overlay: #191919;\n  --rx-bg-toolbar: rgba(25, 25, 25, 0.97);\n  --rx-bg-toolbar-raised: rgba(25, 25, 25, 0.97);\n  --rx-bg-context-active: #C9DEFF;\n  --rx-border-divider: rgba(255, 255, 255, 0.1);\n  --rx-border-input: rgba(255, 255, 255, 0.2);\n  --rx-border-focus: #73A9FF;\n  --rx-fg-dark-accent: #FFFFFF;\n  --rx-fg-dark-heading: rgba(255, 255, 255, 0.9);\n  --rx-fg-dark-text: rgba(255, 255, 255, 0.8);\n  --rx-fg-dark-subtle: rgba(255, 255, 255, 0.6);\n  --rx-fg-dark-minimal: rgba(255, 255, 255, 0.5);\n  --rx-fg-dark-dimmed: rgba(255, 255, 255, 0.4);\n  --rx-bg-dark-dimmed: rgba(255, 255, 255, 0.03);\n  --rx-bg-dark-minimal: rgba(255, 255, 255, 0.05);\n  --rx-bg-dark-subtle: rgba(255, 255, 255, 0.08);\n  --rx-bg-dark-medium: rgba(255, 255, 255, 0.15);\n  --rx-bg-dark-strong: rgba(255, 255, 255, 0.25);\n  --rx-bg-dark-accent: #F7F7F8;\n  --rx-bg-dark-accent-hover: rgba(255, 255, 255, 0.8);\n  --rx-border-dark-dimmed: rgba(255, 255, 255, 0.05);\n  --rx-border-dark-minimal: rgba(255, 255, 255, 0.08);\n  --rx-border-dark-subtle: rgba(255, 255, 255, 0.1);\n  --rx-border-dark-medium: rgba(255, 255, 255, 0.2);\n  --rx-border-dark-accent: #F7F7F8;\n  --rx-fg-light-accent: #070707;\n  --rx-fg-light-heading: rgba(7, 7, 7, 0.9);\n  --rx-fg-light-text: rgba(7, 7, 7, 0.8);\n  --rx-fg-light-subtle: rgba(7, 7, 7, 0.6);\n  --rx-fg-light-minimal: rgba(7, 7, 7, 0.5);\n  --rx-fg-light-dimmed: rgba(7, 7, 7, 0.4);\n  --rx-bg-light-dimmed: rgba(7, 7, 7, 0.03);\n  --rx-bg-light-minimal: rgba(7, 7, 7, 0.05);\n  --rx-bg-light-subtle: rgba(7, 7, 7, 0.08);\n  --rx-bg-light-medium: rgba(7, 7, 7, 0.15);\n  --rx-bg-light-strong: rgba(7, 7, 7, 0.25);\n  --rx-bg-light-accent: #070707;\n  --rx-bg-light-accent-hover: rgba(7, 7, 7, 0.8);\n  --rx-border-light-dimmed: rgba(7, 7, 7, 0.05);\n  --rx-border-light-minimal: rgba(7, 7, 7, 0.08);\n  --rx-border-light-subtle: rgba(7, 7, 7, 0.1);\n  --rx-border-light-medium: rgba(7, 7, 7, 0.2);\n  --rx-border-light-accent: #070707;\n  --rx-fg-primary-accent: #73A9FF;\n  --rx-fg-primary-strong: #99C1FF;\n  --rx-fg-primary-text: #C9DEFF;\n  --rx-bg-primary-minimal: #070D18;\n  --rx-bg-primary-subtle: #061939;\n  --rx-bg-primary-medium: #042C6A;\n  --rx-bg-primary-accent: #73A9FF;\n  --rx-bg-primary-accent-hover: #99C1FF;\n  --rx-bg-primary-static: #0063FF;\n  --rx-border-primary-minimal: #042C6A;\n  --rx-border-primary-subtle: #043583;\n  --rx-border-primary-medium: #043583;\n  --rx-border-primary-accent: #73A9FF;\n  --rx-border-primary-static: #0063FF;\n  --rx-fg-negative-accent: #FF5D6C;\n  --rx-fg-negative-strong: #FF8994;\n  --rx-fg-negative-text: #FFC1C8;\n  --rx-bg-negative-minimal: #160708;\n  --rx-bg-negative-subtle: #31060A;\n  --rx-bg-negative-medium: #5A040D;\n  --rx-bg-negative-accent: #FF5D6C;\n  --rx-bg-negative-accent-hover: #FF8994;\n  --rx-bg-negative-static: #D70015;\n  --rx-border-negative-minimal: #5A040D;\n  --rx-border-negative-subtle: #6F040E;\n  --rx-border-negative-medium: #6F040E;\n  --rx-border-negative-accent: #FF5D6C;\n  --rx-border-negative-static: #D70015;\n  --rx-link-color: #73A9FF;\n  --rx-link-hover-color: #FFFFFF;\n  --rx-link-dark-color: #FFFFFF;\n  --rx-link-dark-hover-color: rgba(255, 255, 255, 0.6);\n  --rx-link-dark-subtle-color: rgba(255, 255, 255, 0.6);\n  --rx-link-dark-subtle-hover-color: #FFFFFF;\n  --rx-shadow-modal: 0 0 1px rgba(255, 255, 255, 0.5), 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);\n  --rx-shadow-dropdown: 0 0 1px rgba(255, 255, 255, 0.4), 0 20px 24px -4px rgba(7, 7, 7, 0.08), 0 8px 8px -4px rgba(7, 7, 7, 0.04);\n  --rx-shadow-sm-border: 0 0 1px rgba(255, 255, 255, 0.5), 0 1px 3px rgba(7, 7, 7, 0.15);\n  --rx-shadow-md-border: 0 0 1px rgba(255, 255, 255, 0.5), 0 1px 2px rgba(7, 7, 7, 0.05), 0 3px 6px rgba(7, 7, 7, 0.05), 0 2px 4px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05);\n  --rx-shadow-lg-border: 0 0 1px rgba(255, 255, 255, 0.5), 0 5px 10px rgba(7, 7, 7, 0.05), 0 10px 20px rgba(7, 7, 7, 0.05), 0 20px 40px rgba(7, 7, 7, 0.05), 0 40px 80px rgba(7, 7, 7, 0.05);\n}\n\n@keyframes slideUp {\n  to {\n    height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-bottom: 0;\n  }\n}\n@keyframes slideDown {\n  from {\n    height: 0;\n    padding-top: 0;\n    padding-bottom: 0;\n    margin-bottom: 0;\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.rx-container {\n  position: relative;\n  box-sizing: border-box;\n}\n\n.rx-container.rx-fullscreen {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 10000;\n  overflow-x: auto;\n}\n\n.rx-main-container {\n  border-radius: var(--rx-rounded-sm);\n  background-color: var(--rx-bg-base);\n  border: 1px solid var(--rx-border-dark-minimal);\n}\n\n.rx-main-wym {\n  background-color: var(--rx-bg-aluminum);\n}\n\n.rx-stop-scrolling {\n  height: 100%;\n  overflow: hidden;\n}\n\n.rx-editor-frame {\n  width: 100%;\n  height: 0;\n  border: none;\n  background-color: var(--rx-bg-base);\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n}\n\n.rx-editor-container {\n  box-sizing: border-box;\n}\n\n.rx-editor-disabled {\n  opacity: 0.4;\n}\n.rx-editor-disabled img {\n  filter: grayscale(1);\n}\n\n.rx-editor-overlay {\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n  background: transparent;\n  top: 0;\n  left: 0;\n}\n\n.rx-toolbox-container {\n  background: var(--rx-bg-toolbar);\n  z-index: var(--rx-level-toolbar);\n}\n\n.rx-editor-breakline table + *, .rx-editor-breakline blockquote + *, .rx-editor-breakline figure + *, .rx-editor-breakline > div + *,\n.rx-editor-breakline p + *, .rx-editor-breakline ul + *, .rx-editor-breakline ol + *, .rx-editor-breakline pre + *, .rx-editor-breakline dl + *, .rx-editor-breakline address + * {\n  margin-top: 0 !important;\n}\n.rx-editor-breakline h1 + h2,\n.rx-editor-breakline h2 + h3,\n.rx-editor-breakline h3 + h4,\n.rx-editor-breakline h4 + h5,\n.rx-editor-breakline h5 + h6 {\n  margin-top: 0 !important;\n}\n\n.rx-editor {\n  overflow: hidden;\n}\n.rx-editor *, .rx-editor *::before, .rx-editor *::after {\n  box-sizing: inherit;\n}\n\n.rx-editor {\n  margin-left: auto;\n  margin-right: auto;\n  box-sizing: border-box;\n}\n.rx-editor *[dir=rtl] {\n  text-align: right;\n}\n.rx-editor *[dir=ltr] {\n  text-align: left;\n}\n.rx-editor, .rx-editor [data-rx-type], .rx-editor a, .rx-editor p, .rx-editor figcaption, .rx-editor td, .rx-editor th {\n  outline: none;\n}\n.rx-editor [data-rx-tag=tbr], .rx-editor [data-rx-tag=br] {\n  margin-top: 0;\n}\n.rx-editor [data-rx-tag=tbr]:empty, .rx-editor [data-rx-tag=br]:empty, .rx-editor [data-rx-type=text]:empty, .rx-editor [data-rx-type=todoitem] div:empty {\n  min-width: 1em;\n  min-height: 1.5em;\n}\n.rx-editor::after {\n  content: \"\";\n  clear: both;\n  display: table;\n}\n.rx-editor [data-rx-type=embed],\n.rx-editor [data-rx-type=image] {\n  position: relative;\n}\n.rx-editor [data-rx-type=embed] img,\n.rx-editor [data-rx-type=image] img {\n  vertical-align: middle;\n}\n.rx-editor figure > img, .rx-editor figure > a img, .rx-editor figure > iframe, .rx-editor figure > pre, .rx-editor figure > div {\n  vertical-align: middle;\n}\n.rx-editor [data-rx-focusable].rx-block-focus {\n  outline: 2px solid var(--rx-border-focus) !important;\n}\n.rx-editor .rx-block-control-focus {\n  outline: 1px solid var(--rx-border-focus) !important;\n  outline-offset: 1px;\n}\n.rx-editor [data-rx-type=wrapper]:empty {\n  outline: 1px dashed var(--rx-border-dark-medium);\n  outline-offset: 1px;\n}\n.rx-editor [data-rx-type=heading] a {\n  text-decoration: underline;\n}\n.rx-editor .rx-layout-grid {\n  display: flex;\n  flex-direction: row;\n  gap: 24px;\n}\n.rx-editor [data-rx-type=column] {\n  outline: 1px dashed var(--rx-border-dark-medium);\n}\n.rx-editor.rx-editor-email [data-rx-type=column] {\n  outline: none;\n}\n.rx-editor.rx-editor-email [data-rx-type=column]:hover, .rx-editor.rx-editor-email [data-rx-type=column]:has(p:empty) {\n  outline: 1px dashed var(--rx-border-dark-medium);\n}\n.rx-editor .rx-nowrap {\n  white-space: nowrap;\n}\n.rx-editor [data-rx-type=pre] {\n  position: relative;\n}\n.rx-editor [data-rx-type=embed] {\n  position: relative;\n}\n.rx-editor [data-rx-type=embed]:before {\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n}\n.rx-editor [data-rx-type=embed] iframe {\n  display: inline-block;\n}\n.rx-editor [data-rx-type=embed] figcaption {\n  position: relative;\n  top: 0;\n  z-index: 2;\n}\n.rx-editor [data-rx-type=embed].rx-block-focus:before {\n  display: none;\n}\n.rx-editor .rx-embed-placeholder {\n  text-align: center;\n  border: 1px dashed var(--rx-border-dark-medium);\n  border-radius: var(--rx-rounded-md);\n  padding: 40px 20px;\n  font-size: 14px;\n  color: var(--rx-fg-placeholder);\n}\n.rx-editor [data-rx-type=todo] {\n  --rx-todo-size: 20px;\n  --rx-todo-mark-color: var(--rx-fg-light-accent);\n  --rx-todo-border-color: var(--rx-border-input);\n  --rx-todo-bg: var(--rx-bg-input);\n  --rx-todo-checked-border-color: var(--rx-border-dark-accent);\n  --rx-todo-checked-bg: var(--rx-bg-dark-accent);\n  margin-left: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.rx-editor [data-rx-type=todoitem] {\n  display: flex;\n  gap: 6px;\n  cursor: text;\n}\n.rx-editor [data-rx-type=todoitem] input {\n  position: relative;\n  top: 1px;\n  appearance: none;\n  display: inline-block;\n  padding: 0;\n  box-shadow: none;\n  width: var(--rx-todo-size);\n  height: var(--rx-todo-size);\n  cursor: pointer;\n}\n.rx-editor [data-rx-type=todoitem] input:before {\n  content: \"\";\n  display: block;\n  width: var(--rx-todo-size);\n  height: var(--rx-todo-size);\n  border: 1px solid var(--rx-todo-border-color);\n  border-radius: 6px;\n  background: var(--rx-todo-bg);\n}\n.rx-editor [data-rx-type=todoitem] input:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: calc(var(--rx-todo-size) / 3.5);\n  height: calc(var(--rx-todo-size) / 1.8);\n  background-color: transparent;\n  transform: translate(-50%, -85%) scale(0) rotate(45deg);\n}\n.rx-editor [data-rx-type=todoitem] input:checked:before {\n  border-color: var(--rx-todo-checked-border-color);\n  background-color: var(--rx-todo-checked-bg);\n  box-shadow: var(--rx-todo-checked-shadow);\n}\n.rx-editor [data-rx-type=todoitem] input:checked:after {\n  transform: translate(-50%, -85%) scale(1) rotate(45deg);\n  box-shadow: 2px 2px 0px 0px var(--rx-todo-mark-color);\n}\n.rx-editor [data-rx-type=todoitem] div {\n  outline: none;\n  line-height: 1.4;\n}\n.rx-editor [data-rx-type=mergetag] {\n  font-family: var(--rx-font-ui-mono);\n  font-size: 85%;\n  line-height: 1;\n  display: inline-block;\n  cursor: pointer;\n  padding: 4px 6px;\n  color: var(--rx-fg-primary-text);\n  background: var(--rx-bg-primary-subtle);\n  border: 1px solid var(--rx-border-primary-subtle);\n  border-radius: 4px;\n}\n.rx-editor [data-rx-type=mergetag]:hover, .rx-editor [data-rx-type=mergetag].rx-block-focus {\n  background: var(--rx-bg-primary-medium);\n}\n.rx-editor .rx-block-placeholder {\n  position: relative;\n}\n.rx-editor .rx-block-placeholder:before {\n  position: absolute;\n}\n.rx-editor .rx-block-placeholder:before,\n.rx-editor [data-placeholder]:empty:before {\n  content: attr(data-placeholder);\n  display: inline-block;\n  color: var(--rx-fg-placeholder);\n  font-weight: normal;\n  font-style: italic;\n  font-size: inherit;\n  cursor: text;\n  max-height: 20px;\n}\n.rx-editor [data-placeholder]:empty:focus:before {\n  content: \"\";\n}\n\n.rx-editor.rx-placeholder:before {\n  position: absolute;\n  z-index: 0;\n  content: attr(placeholder);\n  color: var(--rx-fg-placeholder);\n  font-weight: normal;\n  cursor: text;\n}\n\n.rx-in-blur .rx-editor [data-rx-focusable].rx-block-focus {\n  outline-color: var(--rx-border-dark-medium) !important;\n}\n\n.rx-draggable-placeholder {\n  height: 20px;\n  min-width: 80px;\n  outline: 3px dashed gold !important;\n  background: rgba(255, 215, 0, 0.2) !important;\n  margin-bottom: 20px;\n}\n\n.rx-toolbar-container {\n  display: flex;\n  white-space: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.rx-toolbar-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n.rx-toolbar-container:empty {\n  display: none;\n}\n\n.rx-sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n}\n\n.rx-sticky-on {\n  border-bottom: 1px solid var(--rx-border-dark-minimal);\n}\n\n.rx-raised {\n  margin-left: -1px;\n  margin-right: -1px;\n  margin-top: -1px;\n  margin-bottom: -1px;\n  background: var(--rx-bg-toolbar-raised);\n  box-shadow: var(--rx-shadow-toolbar-raised);\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.rx-toolbox-external.rx-raised {\n  margin: 0;\n}\n\n.rx-raised.rx-sticky-on {\n  border-bottom: none;\n}\n\n.rx-toolbar-buttons,\n.rx-extrabar-buttons {\n  display: flex;\n  white-space: nowrap;\n  align-items: center;\n  gap: 1px;\n}\n\n.rx-toolbar,\n.rx-extrabar {\n  padding: var(--rx-toolbar-padding);\n  height: var(--rx-toolbar-height);\n}\n\n.rx-toolbar {\n  order: 1;\n  flex: 1;\n}\n\n.rx-extrabar {\n  order: 2;\n}\n\n.rx-toolbar .rx-button,\n.rx-extrabar .rx-button {\n  justify-content: center;\n  width: var(--rx-toolbar-button-width);\n  height: var(--rx-toolbar-button-height);\n}\n.rx-toolbar .rx-button-icon,\n.rx-extrabar .rx-button-icon {\n  width: var(--rx-toolbar-button-width);\n  min-width: var(--rx-toolbar-button-width);\n  height: var(--rx-toolbar-button-height);\n}\n.rx-toolbar .rx-button-icon svg,\n.rx-extrabar .rx-button-icon svg {\n  width: var(--rx-toolbar-icon-size);\n  height: var(--rx-toolbar-icon-size);\n}\n.rx-toolbar .rx-button-title,\n.rx-extrabar .rx-button-title {\n  display: none;\n}\n\n.rx-pathbar {\n  font-family: var(--rx-font-ui);\n  margin: 0;\n  padding: 0 8px;\n  position: relative;\n  overflow: hidden;\n  background: var(--rx-bg-toolbar);\n  box-sizing: border-box;\n  border: none;\n  display: flex;\n  gap: 12px;\n  border-bottom: 1px solid var(--rx-border-dark-dimmed);\n}\n.rx-pathbar:empty {\n  display: none;\n}\n\n.rx-pathbar.disable .rx-pathbar-item {\n  opacity: 0.5;\n}\n\n.rx-pathbar-item {\n  position: relative;\n  font-size: 12px;\n  padding: 6px 0;\n  margin: 0;\n  line-height: 16px;\n  color: var(--rx-fg-dark-minimal);\n  cursor: pointer;\n}\n\n.rx-pathbar-item:hover {\n  color: var(--rx-fg-dark-accent);\n  text-decoration: underline;\n}\n\n.rx-pathbar-item.active,\n.rx-pathbar-item.active:hover {\n  color: var(--rx-fg-dark-accent);\n  text-decoration: none;\n  cursor: text;\n}\n\n.rx-pathbar-item:after {\n  position: absolute;\n  content: \"-\";\n  width: 8px;\n  padding-left: 3px;\n  font-size: 12px;\n  line-height: 16px;\n  color: var(--rx-fg-dark-minimal);\n}\n\n.rx-pathbar-item:last-child:after {\n  display: none;\n}\n\n.rx-statusbar {\n  font-family: var(--rx-font-ui-mono);\n  margin: 0;\n  padding: 8px 10px;\n  position: relative;\n  overflow: hidden;\n  background: var(--rx-bg-base);\n  box-sizing: border-box;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.rx-statusbar:empty {\n  display: none;\n}\n\n.rx-statusbar-start,\n.rx-statusbar-end {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rx-statusbar-start {\n  flex: auto;\n}\n\n.rx-statusbar.disable .rx-statusbar-item {\n  opacity: 0.5;\n}\n\n.rx-statusbar-item {\n  font-size: 12px;\n  padding: 0;\n  margin: 0;\n  line-height: 16px;\n  color: var(--rx-fg-text);\n}\n\n.rx-statusbar-item:after {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  top: 2px;\n  width: 1px;\n  height: 12px;\n  margin-left: 10px;\n  background: var(--rx-border-divider);\n}\n\n.rx-statusbar-item:last-child:after {\n  display: none;\n}\n\n.rx-statusbar-item a {\n  color: var(--rx-link-dark-color);\n  text-decoration: underline;\n}\n\n.rx-statusbar-item a:hover {\n  color: var(--rx-link-dark-hover-color);\n  text-decoration: underline;\n}\n\n.rx-fullscreen .rx-statusbar {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n}\n\n.rx-control {\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-family: var(--rx-font-text);\n  z-index: var(--rx-level-control);\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  width: 28px;\n  line-height: 0;\n}\n\n.rx-control-buttons {\n  display: flex;\n  gap: 1;\n  flex-direction: column;\n  flex-wrap: wrap;\n}\n\n.rx-control .rx-button {\n  justify-content: center;\n  background: var(--rx-bg-raised);\n}\n.rx-control .rx-button-title {\n  display: none;\n}\n.rx-control .rx-button-icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n.rx-context {\n  font-family: var(--rx-font-text);\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: var(--rx-level-toolbar);\n  border-radius: var(--rx-rounded-lg);\n  padding: 4px 6px;\n  margin: 0;\n  line-height: 1;\n  background: var(--rx-bg-context);\n  box-shadow: var(--rx-shadow-sm-border);\n  max-width: 380px;\n}\n\n.rx-context-line {\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 1;\n  padding: 6px;\n  padding-bottom: 8px;\n  border-radius: var(--rx-rounded-sm);\n  display: flex;\n  align-items: center;\n  vertical-align: baseline;\n}\n.rx-context-line, .rx-context-line a {\n  color: var(--rx-fg-white-text);\n}\n.rx-context-line a:hover {\n  color: var(--rx-fg-white-subtle);\n}\n\n.rx-context-buttons {\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  flex-wrap: wrap;\n}\n\n.rx-context .rx-button {\n  justify-content: center;\n}\n.rx-context .rx-button:hover, .rx-context .rx-button.toggled, .rx-context .rx-button.active {\n  background: var(--rx-bg-white-medium);\n}\n.rx-context .rx-button:hover .rx-button-icon svg, .rx-context .rx-button.toggled .rx-button-icon svg, .rx-context .rx-button.active .rx-button-icon svg {\n  fill: var(--rx-fg-white-text);\n}\n.rx-context .rx-button.disabled .rx-button-icon svg {\n  fill: var(--rx-fg-white-dimmed);\n}\n.rx-context .rx-button-icon {\n  border-radius: var(--rx-rounded-md);\n}\n.rx-context .rx-button-icon svg {\n  fill: var(--rx-fg-white-text);\n  width: 18px;\n  height: 18px;\n}\n.rx-context .rx-button-title {\n  display: none;\n}\n\n.rx-button {\n  font-family: var(--rx-font-text);\n  display: flex;\n  align-items: center;\n  vertical-align: middle;\n  text-decoration: none;\n  background: none;\n  outline: none;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-size: 0px;\n  line-height: 1;\n  gap: 8px;\n  border-radius: var(--rx-rounded-sm);\n  width: 28px;\n  height: 28px;\n  transition: none;\n  cursor: pointer;\n}\n.rx-button.pressed {\n  background: var(--rx-bg-silver);\n}\n.rx-button.pressed .rx-button-icon svg {\n  fill: var(--rx-fg-dark-accent);\n}\n.rx-button:hover {\n  text-decoration: none;\n}\n.rx-button:hover {\n  background: var(--rx-bg-silver);\n}\n.rx-button:hover .rx-button-icon svg {\n  fill: var(--rx-fg-dark-accent);\n}\n.rx-button.active {\n  background: var(--rx-bg-silver);\n}\n.rx-button.disabled {\n  cursor: default;\n  background-color: transparent !important;\n}\n.rx-button.disabled .rx-button-icon svg {\n  fill: var(--rx-fg-dark-dimmed);\n}\n\n.rx-button-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  vertical-align: middle;\n  border-radius: var(--rx-rounded-sm);\n  width: 28px;\n  min-width: 28px;\n  height: 28px;\n}\n.rx-button-icon:empty {\n  display: none;\n}\n.rx-button-icon svg {\n  fill: var(--rx-fg-dark-text);\n  width: 16px;\n  height: 16px;\n}\n\n.rx-button-title {\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.4;\n  color: var(--rx-fg-dark-text);\n}\n\n.rx-tooltip {\n  position: absolute;\n  z-index: 99;\n  margin: 0;\n  padding: 4px 7px;\n  border-radius: var(--rx-rounded-sm);\n  line-height: 1;\n  font-family: var(--rx-font-ui-mono);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--rx-fg-white-text);\n  background: var(--rx-bg-black-accent);\n  pointer-events: none;\n}\n\n.rx-source-container {\n  display: none;\n}\n\n.rx-source,\n.rx-source:hover,\n.rx-source:focus {\n  text-align: left;\n  box-sizing: border-box;\n  font-family: var(--rx-font-ui-mono);\n  width: 100%;\n  display: block;\n  margin: 0;\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n  background-color: var(--rx-bg-source);\n  color: var(--rx-fg-white-text);\n  font-size: 14px;\n  line-height: 1.7;\n  outline: none;\n  padding: 10px 18px 20px 18px;\n  min-height: 60px;\n  resize: vertical;\n}\n\n.rx-drag-active {\n  outline: 3px dashed gold !important;\n  outline-offset: 0 !important;\n  position: relative;\n  max-height: 40px;\n  overflow: hidden;\n  padding: 0;\n}\n.rx-drag-active:before {\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  top: 0;\n  left: 0;\n  background: rgba(255, 215, 0, 0.4);\n  position: absolute;\n  z-index: 1;\n}\n\n.rx-dragging {\n  opacity: 0.95;\n  padding: 8px;\n  background: var(--rx-bg-body);\n  box-shadow: var(--rx-shadow-reorder);\n}\n.rx-dragging img {\n  max-width: 100%;\n}\n\n.rx-dropdown,\n.rx-colorpicker {\n  position: absolute;\n  font-family: var(--rx-font-ui);\n  border-radius: var(--rx-rounded-md);\n  background: var(--rx-bg-overlay);\n  box-shadow: var(--rx-shadow-dropdown);\n  position: absolute;\n  top: 0;\n  left: 0;\n  font-size: 14px;\n  line-height: 1.4;\n  z-index: var(--rx-level-popup);\n  margin-bottom: 16px;\n  overflow-x: auto;\n  min-width: 200px;\n  padding: 4px;\n}\n\n.rx-dropdown[data-rx-pos=top] {\n  box-shadow: none;\n}\n\n.rx-dropdown-swatches {\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.rx-dropdown-swatches-wrap {\n  flex-wrap: wrap;\n}\n\n.rx-dropdown-swatches-colors {\n  display: flex;\n  flex-direction: column;\n}\n\n.rx-dropdown-swatches-colors-row {\n  flex-direction: row;\n}\n\n.rx-dropdown-swatch {\n  cursor: pointer;\n  position: relative;\n  font-size: 0;\n  width: 20px;\n  height: 20px;\n  border: 1px solid transparent;\n}\n.rx-dropdown-swatch.active {\n  border: 2px solid var(--rx-border-dark-accent);\n  box-shadow: 0 0 0 2px var(--rx-border-light-accent);\n  z-index: 2;\n}\n\n.rx-dropdown-swatch-size-large {\n  width: 32px;\n  height: 32px;\n}\n\n.rx-dropdown-color-contrast {\n  border-color: var(--rx-border-dark-subtle);\n}\n\n.rx-dropdown-tabs {\n  font-size: 13px;\n  line-height: 1;\n  font-weight: 500;\n  display: flex;\n  gap: 2px;\n  border-radius: var(--rx-rounded-sm);\n  background: var(--rx-bg-dark-minimal);\n  padding: 2px;\n  margin-bottom: 4px;\n}\n\n.rx-dropdown-tab {\n  flex-grow: 1;\n  border-radius: var(--rx-rounded-sm);\n  padding: 6px 8px;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  color: var(--rx-fg-dark-subtle);\n}\n\n.rx-dropdown-tab:hover,\n.rx-dropdown-tab.active {\n  text-decoration: none;\n  background: var(--rx-bg-dark-subtle);\n  color: var(--rx-fg-dark-text);\n}\n\n.rx-dropdown-tab.active {\n  cursor: text;\n  text-decoration: none;\n  background: var(--rx-bg-light-accent);\n  color: var(--rx-fg-dark-text);\n  box-shadow: var(--shadow-sm-border);\n}\n\n.rx-dropdown-item,\n.rx-dropdown-item:hover {\n  font-size: 14px;\n  line-height: 1.4;\n  padding: 6px;\n  display: flex;\n  color: var(--rx-fg-dark-text);\n  background: none;\n  cursor: default;\n  border-bottom: 1px solid var(--rx-border-dark-dimmed);\n}\n.rx-dropdown-item .rx-button-title,\n.rx-dropdown-item:hover .rx-button-title {\n  display: none;\n}\n\n.rx-dropdown-item:last-child {\n  border-bottom-width: 0;\n}\n\n.rx-dropdown-item-hotkey {\n  margin-left: auto;\n  font-weight: normal;\n  display: flex;\n  gap: 1px;\n  align-items: center;\n  color: var(--rx-fg-dark-minimal);\n  font-family: var(--rx-font-ui);\n  font-size: 12px;\n  line-height: 16px;\n}\n.rx-dropdown-item-hotkey span {\n  padding: 0 2px;\n  height: 16px;\n}\n\n.rx-dropdown .rx-button {\n  position: relative;\n  padding: 8px 10px;\n  height: auto;\n  width: 100%;\n  border-radius: var(--rx-rounded-md);\n}\n.rx-dropdown .rx-button-icon {\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n}\n.rx-dropdown .rx-button.rx-button-swatch {\n  width: 20px;\n  height: 20px;\n  border-radius: 0;\n}\n.rx-dropdown .rx-button.rx-button-swatch .rx-button-icon,\n.rx-dropdown .rx-button.rx-button-swatch .rx-button-title {\n  display: none;\n}\n.rx-dropdown .rx-button-title {\n  color: var(--rx-fg-dark-accent);\n}\n.rx-dropdown .rx-button-danger .rx-button-title {\n  color: var(--rx-fg-negative-accent);\n}\n.rx-dropdown .rx-button-danger svg {\n  fill: var(--rx-fg-negative-accent);\n}\n.rx-dropdown .rx-button.disabled .rx-button-title {\n  color: var(--rx-fg-dark-minimal);\n}\n.rx-dropdown .rx-button.disabled svg {\n  fill: var(--rx-fg-dark-minimal);\n}\n\n.rx-dropdown-type-grid .rx-dropdown-items {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0;\n  box-sizing: border-box;\n}\n.rx-dropdown-type-grid .rx-button {\n  box-sizing: border-box;\n  border-radius: 0;\n  margin-bottom: -1px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n  padding: 0;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  color: var(--rx-fg-dark-text);\n}\n.rx-dropdown-type-grid .rx-button:after {\n  display: none;\n}\n.rx-dropdown-type-grid .rx-button-title:empty {\n  display: none;\n}\n.rx-dropdown-type-grid .rx-dropdown-item svg {\n  width: 16px;\n  height: 16px;\n}\n\n.rx-dropdown-stack {\n  padding: 16px;\n  padding-top: 0;\n}\n\n.rx-dropdown-stack-item {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  line-height: 1;\n  border-bottom: 1px solid var(--rx-border-dark-dimmed);\n}\n\n.rx-dropdown-stack-item:last-child {\n  border-bottom-color: transparent;\n}\n\n.rx-dropdown-stack-item:hover {\n  background-color: var(--rx-bg-dark-minimal);\n}\n\n.rx-dropdown-stack-title {\n  text-decoration: none;\n  flex: 1;\n  padding: 7px 8px;\n  font-size: 14px;\n  color: var(--rx-fg-dark-text);\n}\n\n.rx-dropdown-stack-aside {\n  font-family: var(--rx-font-ui-mono);\n  font-size: 11px;\n  color: var(--rx-fg-dark-subtle);\n  margin-left: auto;\n  padding-left: 4px;\n}\n\n.rx-modal {\n  position: absolute;\n  overflow-x: hidden;\n  overflow-y: auto;\n  margin-bottom: 16px;\n  min-width: 200px;\n  font-family: var(--rx-font-ui);\n  border-radius: var(--rx-rounded-md);\n  background-color: var(--rx-bg-overlay);\n  box-shadow: var(--rx-shadow-modal);\n  z-index: var(--rx-level-popup);\n}\n\n.rx-modal-body .rx-form {\n  padding-bottom: 0;\n}\n\n.rx-modal-header {\n  font-size: 16px;\n  font-weight: bold;\n  color: var(--rx-bg-dark-accent);\n  padding: 16px;\n  position: relative;\n}\n.rx-modal-header:empty {\n  display: none;\n}\n\n.rx-modal-footer {\n  overflow: hidden;\n  box-sizing: border-box;\n  margin-top: 8px;\n  padding: 16px;\n  padding-bottom: 20px;\n  display: flex;\n  gap: 4px;\n}\n.rx-modal-footer:empty {\n  display: none;\n}\n\n.rx-modal-close {\n  position: absolute !important;\n  right: 16px;\n  top: 14px;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n}\n.rx-modal-close::before, .rx-modal-close::after {\n  content: \"\";\n  display: block;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%) rotate(45deg);\n  background: var(--rx-bg-dark-accent);\n}\n.rx-modal-close::before {\n  height: 1px;\n  width: 75%;\n}\n.rx-modal-close::after {\n  height: 75%;\n  width: 1px;\n}\n.rx-modal-close:hover {\n  opacity: 1;\n}\n\n.rx-modal-tabs {\n  margin: 0 16px;\n  padding: 0;\n  border: 1px solid var(--rx-border-dark-dimmed);\n  border-radius: 99px;\n  display: inline-flex;\n  gap: 0;\n}\n\n.rx-modal-tab {\n  font-size: 14px;\n  font-weight: normal;\n  color: var(--rx-fg-text);\n  text-decoration: none;\n  border-radius: 99px;\n  padding: 8px 16px;\n  line-height: 1;\n}\n\n.rx-modal-tab:hover {\n  color: var(--rx-fg-text);\n  background: var(--rx-bg-dark-minimal);\n}\n\n.rx-modal-tab.active {\n  color: var(--rx-fg-light-accent);\n  background: var(--rx-bg-dark-accent);\n}\n\n.rx-form {\n  padding: 0 16px 0 16px;\n}\n.rx-form-item {\n  padding-bottom: 16px;\n}\n.rx-form-item:empty {\n  display: none;\n}\n.rx-form-box {\n  padding: 16px;\n}\n.rx-form-image img, .rx-form-image svg {\n  max-width: 100%;\n}\n.rx-form-title, .rx-form-section {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--rx-bg-dark-accent);\n  padding: 16px 0;\n}\n.rx-form-title:empty, .rx-form-section:empty {\n  display: none;\n}\n.rx-form-label {\n  box-sizing: border-box;\n  font-family: var(--rx-font-ui);\n  font-size: 14px;\n  line-height: 1.4;\n  font-weight: 500;\n  display: block;\n  padding: 0;\n  margin: 0;\n  padding-bottom: 6px;\n  color: var(--rx-fg-dark-text);\n}\n.rx-form-hint {\n  font-size: 13px;\n  font-weight: normal;\n  color: var(--rx-fg-dark-subtle);\n  margin-left: 2px;\n}\n\n.rx-form-flex {\n  display: flex;\n  gap: 8px;\n}\n.rx-form-flex .rx-form-input,\n.rx-form-flex .rx-form-select {\n  flex: auto;\n}\n\n.rx-form-color-container {\n  position: relative;\n}\n.rx-form-color-container .rx-form-input {\n  padding-left: 40px;\n}\n\n.rx-form-color-toggle {\n  position: absolute;\n  top: 4px;\n  left: 6px;\n  height: 28px;\n  width: 28px;\n  border-radius: 8px;\n  box-shadow: var(--rx-shadow-inner);\n  cursor: pointer;\n  background: var(--rx-bg-white-accent);\n}\n\n.rx-form-button {\n  box-sizing: border-box;\n  font-family: var(--rx-font-ui);\n  font-size: 14px;\n  font-weight: 500;\n  outline: none;\n  border-radius: 6px;\n  padding: 8px 20px;\n  min-height: 40px;\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  line-height: 1.25;\n  height: auto;\n  background: transparent;\n  color: var(--rx-fg-dark-accent);\n  border: 1px solid var(--rx-border-dark-medium);\n}\n.rx-form-button:hover {\n  background: var(--rx-bg-dark-subtle);\n}\n.rx-form-button-primary {\n  background: var(--rx-bg-dark-accent);\n  color: var(--rx-fg-light-accent);\n  border-color: transparent;\n}\n.rx-form-button-primary:hover {\n  color: var(--rx-fg-light-accent);\n  background: var(--rx-bg-dark-accent-hover);\n}\n.rx-form-button-danger {\n  border: 1px solid var(--rx-border-negative-medium);\n  color: var(--rx-fg-negative-accent);\n}\n.rx-form-button-danger:hover {\n  color: var(--rx-fg-negative-accent);\n  background: var(--rx-bg-negative-subtle);\n}\n.rx-form-button-fullwidth {\n  display: block;\n  width: 100%;\n}\n.rx-form-button-push-right {\n  margin-left: auto;\n}\n\n.rx-form-input,\n.rx-form-select,\n.rx-form-textarea {\n  box-sizing: border-box;\n  display: block;\n  width: 100%;\n  font-weight: normal;\n  padding: 8px;\n  font-family: var(--rx-font-ui);\n  font-size: 15px;\n  outline: none;\n  border-radius: 4px;\n  box-shadow: none;\n  line-height: 1.3;\n  color: var(--rx-fg-dark-text);\n  background: var(--rx-bg-input-shaded);\n  border: 1px solid var(--rx-border-input);\n}\n.rx-form-input:focus,\n.rx-form-select:focus,\n.rx-form-textarea:focus {\n  border-color: var(--rx-border-focus);\n  box-shadow: 0 0 0 1px var(--rx-border-focus);\n}\n\n.rx-form-textarea {\n  resize: vertical;\n  line-height: 1.5;\n}\n\n.rx-form-select {\n  font-size: 15px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  background-image: url('data:image/svg+xml;utf8,<svg height=\"6\" viewBox=\"0 0 10 6\" width=\"10\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"rgb(0,0,0)\" opacity=\".6\" d=\"m6.6168815 3-4.44908109-4.09883609c-.22373388-.20615371-.22373388-.54039492 0-.74654863s.58647818-.20615371.81021206 0l4.85418712 4.47211041c.22373388.20615371.22373388.54039491 0 .74654862l-4.85418712 4.47211041c-.22373388.20615371-.58647818.20615371-.81021206 0s-.22373388-.54039492 0-.74654863z\" fill-rule=\"evenodd\" transform=\"matrix(0 1 -1 0 8 -2)\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 0.65em center;\n  padding-right: 28px;\n  min-height: 35px;\n}\n\n[rx-data-theme=dark] .rx-form-select {\n  background-image: url('data:image/svg+xml;utf8,<svg height=\"6\" viewBox=\"0 0 10 6\" width=\"10\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"rgb(255,255,255)\" opacity=\"0.6\" d=\"m6.6168815 3-4.44908109-4.09883609c-.22373388-.20615371-.22373388-.54039492 0-.74654863s.58647818-.20615371.81021206 0l4.85418712 4.47211041c.22373388.20615371.22373388.54039491 0 .74654862l-4.85418712 4.47211041c-.22373388.20615371-.58647818.20615371-.81021206 0s-.22373388-.54039492 0-.74654863z\" fill-rule=\"evenodd\" transform=\"matrix(0 1 -1 0 8 -2)\"/></svg>');\n}\n\n.rx-form-checkbox {\n  box-sizing: border-box;\n  vertical-align: middle;\n  margin: 0 !important;\n  margin-right: 4px !important;\n}\n\n.rx-form-checkbox-label {\n  color: var(--rx-fg-dark-text);\n  font-family: var(--rx-font-ui);\n  font-size: 15px;\n  line-height: 1.4;\n}\n\n.rx-form-upload-box {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  margin-bottom: 10px;\n  border: 1px dashed var(--rx-border-dark-medium);\n  background: var(--rx-bg-dark-dimmed);\n  border-radius: var(--rx-rounded-md);\n  min-width: 160px;\n  height: 160px;\n  cursor: pointer;\n  position: relative;\n}\n.rx-form-upload-box input[type=file] {\n  font-size: 13px;\n}\n.rx-form-upload-box img {\n  position: relative;\n  z-index: 2;\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n}\n.rx-form-upload-box:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n}\n.rx-form-upload-box.rx-form-upload-hover {\n  border-color: var(--rx-border-dark-medium);\n  background-color: var(--rx-bg-dark-subtle);\n}\n.rx-form-upload-box.rx-form-upload-error {\n  border-color: var(--rx-border-negative-medium);\n  background-color: var(--rx-bg-negative-minimal);\n}\n\n.rx-upload-remove {\n  position: absolute;\n  z-index: 3;\n  top: -6px;\n  right: -10px;\n  background-color: var(--rx-bg-black-accent);\n  color: var(--rx-fg-white-accent);\n  opacity: 1;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  border-radius: 10px;\n  font-size: 14px;\n  line-height: 20px;\n}\n.rx-upload-remove:after {\n  content: \"×\";\n}\n.rx-upload-remove:hover {\n  background-color: var(--rx-bg-black-accent-hover);\n}\n\n.rx-form-upload-cover-off img {\n  object-fit: initial;\n  height: auto;\n  width: auto;\n}\n\n.rx-form-upload-placeholder {\n  font-family: var(--rx-font-ui);\n  color: var(--rx-fg-dark-minimal);\n  font-size: 12px;\n  line-height: 1.35;\n  padding: 0 8px;\n  text-align: center;\n}\n.rx-form-upload-placeholder svg {\n  fill: var(--rx-fg-dark-minimal);\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 40px 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n.rx-editor-progress {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 11000;\n  width: 100%;\n  background-color: var(--rx-bg-dark-subtle);\n}\n.rx-editor-progress span {\n  animation: progress-bar-stripes 2s linear infinite;\n  content: \"\";\n  display: block;\n  min-height: 8px;\n  width: 100%;\n  height: 100%;\n  background-color: var(--rx-bg-primary-accent);\n  background-image: -webkit-linear-gradient(45deg, var(--rx-bg-light-strong) 25%, transparent 25%, transparent 50%, var(--rx-bg-light-strong) 50%, var(--rx-bg-light-strong) 75%, transparent 75%, transparent);\n  background-image: linear-gradient(45deg, var(--rx-bg-light-strong) 25%, transparent 25%, transparent 50%, var(--rx-bg-light-strong) 50%, var(--rx-bg-light-strong) 75%, transparent 75%, transparent);\n  background-size: 40px 40px;\n}\n\n.rx-panel {\n  position: absolute;\n  min-width: 240px;\n  max-height: 300px;\n  margin: 0;\n  padding: 0;\n  z-index: 99;\n  font-family: var(--rx-font-ui);\n  font-size: 14px;\n  overflow: auto;\n  border-radius: 4px;\n  padding: 4px;\n  background: var(--rx-bg-overlay);\n  box-shadow: var(--rx-shadow-dropdown);\n}\n\n.rx-panel-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n}\n\n.rx-panel-title {\n  font-family: var(--rx-font-ui);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--rx-fg-dark-subtle);\n}\n\n.rx-panel-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n}\n\n.rx-panel-item {\n  box-sizing: border-box;\n  padding: 4px;\n  border-bottom: 1px solid transparent;\n}\n\n.rx-panel-item {\n  display: flex;\n  align-items: center;\n  vertical-align: middle;\n  gap: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 8px;\n  line-height: 1;\n  text-decoration: none;\n  color: var(--rx-fg-dark-accent);\n}\n\n.rx-panel-item:hover {\n  color: var(--rx-fg-dark-accent);\n  background: var(--rx-bg-dark-subtle);\n}\n\n.rx-panel-item.active {\n  color: var(--rx-fg-dark-accent);\n  background: var(--rx-bg-primary-medium);\n}\n\n.rx-panel-item-icon {\n  min-width: 16px;\n}\n\n.rx-panel-item-icon svg {\n  width: 16px;\n  height: 16px;\n  fill: var(--rx-fg-dark-accent);\n}\n\n.rx-panel-stack .rx-panel-box {\n  flex-direction: column;\n}\n\n.rx-ai-main {\n  padding: 12px;\n  border-radius: 8px;\n  background: var(--rx-bg-raised);\n  border: 1px solid var(--rx-border-dark-subtle);\n}\n\n.rx-ai-footer {\n  margin-top: 16px !important;\n  display: flex;\n  gap: 8px;\n}\n\n.rx-ai-buttons {\n  margin-left: auto !important;\n  display: flex;\n  gap: 8px;\n}\n\n.rx-ai-preview-label,\n.rx-ai-label {\n  box-sizing: border-box;\n  font-family: var(--rx-font-ui);\n  font-size: 13px;\n  line-height: 1.4;\n  font-weight: 500;\n  display: block;\n  padding: 0;\n  margin: 0;\n  padding-bottom: 6px;\n  color: var(--rx-fg-dark-subtle);\n}\n\n.rx-ai-select,\n.rx-ai-size {\n  width: auto;\n  max-width: 320px;\n}\n\n.rx-ai-progress {\n  margin-bottom: 12px !important;\n}\n.rx-ai-progress:empty {\n  display: none;\n}\n.rx-ai-progress svg {\n  fill: var(--rx-fg-dark-accent);\n}\n\n.rx-ai-preview {\n  font-family: var(--rx-font-ui);\n  font-weight: normal;\n  letter-spacing: normal;\n  text-transform: none;\n  font-size: 16px;\n  line-height: 1.618;\n  color: var(--rx-fg-dark-text);\n  margin-bottom: 12px !important;\n}\n.rx-ai-preview:empty {\n  display: none;\n}\n\n@media only screen and (max-width: 767px) {\n  .rx-ai-footer,\n  .rx-ai-buttons {\n    flex-direction: column;\n    width: 100%;\n  }\n  .rx-ai-select,\n  .rx-ai-size {\n    max-width: 100%;\n  }\n  .rx-ai-button {\n    justify-content: center;\n  }\n}\n.rx-voice-label {\n  display: none;\n}\n\n.rx-visually-hidden {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.rx-hidden {\n  display: none !important;\n}\n\n.rx-code-lang-select {\n  position: absolute;\n  top: 2px;\n  right: 4px;\n  z-index: 3;\n}\n\n.rx-collapsed {\n  position: relative;\n}\n\n.rx-collapsed:before {\n  content: \"›\";\n  position: absolute;\n  left: -12px;\n  line-height: 1;\n  top: 50%;\n  margin-top: -7px;\n  font-size: 14px;\n}\n\n.rx-toc {\n  margin-bottom: 24px;\n}\n\n[rx-modal-name=image] .rx-modal-body {\n  padding: 16px;\n  padding-top: 0;\n}\n\n.rx-modal-image-section-or {\n  margin: 16px 0;\n  font-family: var(--rx-font-ui);\n  text-transform: uppercase;\n  font-weight: bold;\n  text-align: center;\n  font-size: 11px;\n  color: var(--rx-fg-dark-subtle);\n}\n\n.rx-modal-images-box {\n  margin-top: 12px;\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n.rx-modal-images-box img {\n  vertical-align: top;\n  max-width: 100px;\n  max-height: 66px;\n  height: 100%;\n  width: min-content;\n  cursor: pointer;\n}\n.rx-modal-images-box img:hover {\n  outline: 3px solid var(--rx-border-focus);\n}\n\n.rx-modal-images-box-edit {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.rx-form-item-edit-image-box {\n  padding: 20px;\n  padding-bottom: 0;\n}\n\n.rx-form-item-image {\n  margin-right: 8px;\n}\n.rx-form-item-image img {\n  max-height: 160px;\n  width: auto;\n}\n\n[rx-modal-name=emoji] .rx-modal-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rx-emoji-title {\n  font-family: var(--rx-font-ui);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--rx-fg-dark-subtle);\n}\n\n.rx-emoji-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n}\n\n.rx-emoji-item {\n  border-radius: 4px;\n  padding: 4px;\n  cursor: pointer;\n  font-size: 24px;\n  line-height: 1;\n}\n\n.rx-emoji-item:hover {\n  background: var(--rx-bg-dark-subtle);\n}\n\n.rx-panel-emoji {\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rx-panel-emoji .rx-panel-item {\n  font-size: 24px;\n}\n\n[rx-modal-name=snippets] .rx-modal-body,\n[rx-modal-name=templates] .rx-modal-body {\n  padding: 20px;\n  padding-bottom: 0;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.rx-snippet-container {\n  box-sizing: border-box;\n  margin-right: 10px;\n  margin-bottom: 20px;\n}\n\n.rx-snippet-name {\n  box-sizing: border-box;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: var(--rx-font-ui);\n  color: var(--rx-fg-dark-text);\n  margin-top: 8px;\n  padding-right: 10px;\n  text-align: left;\n  max-width: 100px;\n}\n\n.rx-snippet-box {\n  box-sizing: border-box;\n  border-radius: 6px;\n  box-shadow: var(--shadow-md-border);\n  cursor: pointer;\n  border: 1px solid transparent;\n  overflow: hidden;\n}\n.rx-snippet-box:hover {\n  border: 1px solid var(--rx-border-primary-accent);\n}\n\n.rx-snippet-image,\n.rx-template-image {\n  min-height: 80px;\n  max-height: 80px;\n  box-sizing: border-box;\n}\n.rx-snippet-image img,\n.rx-template-image img {\n  max-width: 160px;\n}\n\n.rx-template-image {\n  min-height: 130px;\n  max-height: initial;\n}\n.rx-template-image img {\n  max-width: 100px;\n}\n\n.rx-snippet-preview,\n.rx-template-preview {\n  box-sizing: border-box;\n  overflow: hidden;\n  transform-origin: top left;\n  transform: scale(0.25);\n  margin-right: -480px;\n  margin-bottom: -240px;\n  padding: 40px;\n  width: 640px;\n  height: 320px;\n  position: relative;\n}\n.rx-snippet-preview:before,\n.rx-template-preview:before {\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n  position: absolute;\n  z-index: 1;\n}\n.rx-snippet-preview:hover,\n.rx-template-preview:hover {\n  border-color: var(--rx-border-primary-accent);\n}\n.rx-snippet-preview fieldset, .rx-snippet-preview iframe, .rx-snippet-preview img,\n.rx-template-preview fieldset,\n.rx-template-preview iframe,\n.rx-template-preview img {\n  border: 0;\n}\n.rx-snippet-preview embed, .rx-snippet-preview object, .rx-snippet-preview audio, .rx-snippet-preview img, .rx-snippet-preview video,\n.rx-template-preview embed,\n.rx-template-preview object,\n.rx-template-preview audio,\n.rx-template-preview img,\n.rx-template-preview video {\n  max-width: 100%;\n  height: auto;\n}\n.rx-snippet-preview h1:empty,\n.rx-snippet-preview h2:empty,\n.rx-snippet-preview h3:empty,\n.rx-snippet-preview h4:empty,\n.rx-snippet-preview h5:empty,\n.rx-snippet-preview h6:empty,\n.rx-snippet-preview p:empty,\n.rx-snippet-preview div:empty,\n.rx-template-preview h1:empty,\n.rx-template-preview h2:empty,\n.rx-template-preview h3:empty,\n.rx-template-preview h4:empty,\n.rx-template-preview h5:empty,\n.rx-template-preview h6:empty,\n.rx-template-preview p:empty,\n.rx-template-preview div:empty {\n  background-color: var(--rx-border-primary-subtle);\n  min-height: 1.5em;\n}\n\n.rx-template-preview {\n  transform: scale(0.25);\n  margin-right: -300px;\n  margin-bottom: -390px;\n  padding: 40px;\n  width: 400px;\n  height: 520px;\n}\n\n.rx-empty h1:empty,\n.rx-empty h2:empty,\n.rx-empty h3:empty,\n.rx-empty h4:empty,\n.rx-empty h5:empty,\n.rx-empty h6:empty,\n.rx-empty p:empty,\n.rx-empty li:empty,\n.rx-empty dt:empty,\n.rx-empty dd:empty,\n.rx-empty address:empty,\n.rx-empty figcaption:empty,\n.rx-empty blockquote:empty {\n  min-height: 1.5em;\n}\n.rx-empty pre:empty {\n  min-height: 3.5em;\n}\n.rx-empty strong:empty, .rx-empty b:empty, .rx-empty em:empty, .rx-empty i:empty, .rx-empty span:empty, .rx-empty sup:empty, .rx-empty sub:empty, .rx-empty u:empty, .rx-empty ins:empty, .rx-empty code:empty, .rx-empty del:empty, .rx-empty cite:empty {\n  display: inline-block;\n  min-width: 1px;\n  min-height: 1em;\n}\n.rx-empty th:empty:after, .rx-empty td:empty:after {\n  content: \"​\";\n}\n.rx-empty code:after, .rx-empty kbd:after, .rx-empty mark:after {\n  content: \"​\";\n}\n.rx-empty pre code:after {\n  display: none;\n}\n.rx-empty code + code {\n  margin-left: 2px;\n}\n.rx-empty table {\n  empty-cells: show;\n}\n.rx-empty embed, .rx-empty img, .rx-empty object {\n  max-width: 100%;\n  height: auto;\n}\n\n.rx-content {\n  text-align: left;\n  --rx-font-text: -apple-system, BlinkMacSystemFont, \"San Francisco\", \"Segoe UI\", Roboto, \"Helvetica Neue\", sans-serif;\n  --rx-font-heading: inherit;\n  --rx-font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --rx-body-color: var(--rx-bg-body);\n  --rx-heading-color: var(--rx-fg-heading);\n  --rx-text-color: var(--rx-fg-text);\n  --rx-table-border: var(--rx-border-dark-minimal);\n  --rx-line-color: var(--rx-border-dark-minimal);\n  --rx-pre-color: var(--rx-fg-text);\n  --rx-pre-bg: var(--rx-bg-dark-minimal);\n  --rx-var-color: var(--rx-fg-text);\n  --rx-kbd-color: var(--rx-fg-text);\n  --rx-kbd-border: var(--rx-border-dark-subtle);\n  --rx-kbd-bg: var(--rx-bg-light-accent);\n  --rx-code-color: var(--rx-fg-text);\n  --rx-code-bg: var(--rx-bg-dark-medium);\n  --rx-abbr-border: var(--rx-border-dark-accent);\n  --rx-quote-border-color: var(--rx-border-dark-accent);\n  background: var(--rx-body-color);\n  font-family: var(--rx-font-text);\n  color: var(--rx-text-color);\n  font-size: 16px;\n  line-height: 1.5;\n}\n.rx-content[dir=rtl] {\n  text-align: right;\n}\n.rx-content * {\n  margin: 0;\n}\n.rx-content p, .rx-content li, .rx-content dt, .rx-content dd, .rx-content address {\n  font-size: 16px;\n  line-height: 1.5;\n}\n.rx-content h1 + *, .rx-content h2 + *, .rx-content h3 + *, .rx-content h4 + *, .rx-content h5 + *, .rx-content h6 + * {\n  margin-top: 12px;\n}\n.rx-content p + h2, .rx-content p + h3, .rx-content p + h4, .rx-content p + h5, .rx-content p + h6, .rx-content ul + h2, .rx-content ul + h3, .rx-content ul + h4, .rx-content ul + h5, .rx-content ul + h6, .rx-content ol + h2, .rx-content ol + h3, .rx-content ol + h4, .rx-content ol + h5, .rx-content ol + h6, .rx-content pre + h2, .rx-content pre + h3, .rx-content pre + h4, .rx-content pre + h5, .rx-content pre + h6, .rx-content dl + h2, .rx-content dl + h3, .rx-content dl + h4, .rx-content dl + h5, .rx-content dl + h6, .rx-content address + h2, .rx-content address + h3, .rx-content address + h4, .rx-content address + h5, .rx-content address + h6 {\n  margin-top: 24px;\n}\n.rx-content p + *, .rx-content ul + *, .rx-content ol + *, .rx-content pre + *, .rx-content dl + *, .rx-content address + * {\n  margin-top: 24px;\n}\n.rx-content table + *,\n.rx-content blockquote + *,\n.rx-content figure + *, .rx-content > div + * {\n  margin-top: 24px;\n}\n.rx-content h1 + h2,\n.rx-content h2 + h3,\n.rx-content h3 + h4,\n.rx-content h4 + h5,\n.rx-content h5 + h6 {\n  margin-top: 12px;\n}\n.rx-content a,\n.rx-content a:hover,\n.rx-content a:focus,\n.rx-content a:visited {\n  color: var(--rx-link-color);\n}\n.rx-content h1,\n.rx-content h2,\n.rx-content h3,\n.rx-content h4,\n.rx-content h5,\n.rx-content h6 {\n  font-family: var(--rx-font-heading);\n  font-weight: bold;\n  font-style: normal;\n  color: var(--rx-heading-color);\n  text-rendering: optimizeLegibility;\n  letter-spacing: 0;\n}\n.rx-content h1 a,\n.rx-content h2 a,\n.rx-content h3 a,\n.rx-content h4 a,\n.rx-content h5 a,\n.rx-content h6 a {\n  text-decoration: underline;\n}\n.rx-content h1 {\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n.rx-content h2 {\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n.rx-content h3,\n.rx-content h4,\n.rx-content h5,\n.rx-content h6 {\n  font-weight: 600;\n  letter-spacing: -0.01em;\n}\n.rx-content h1 {\n  font-size: 36px;\n  line-height: 1.25;\n}\n.rx-content h2 {\n  font-size: 24px;\n  line-height: 1.25;\n}\n.rx-content h3 {\n  font-size: 20px;\n  line-height: 1.25;\n}\n.rx-content h4 {\n  font-size: 16px;\n  line-height: 1.25;\n}\n.rx-content h5 {\n  font-size: 16px;\n  line-height: 1.25;\n}\n.rx-content h6 {\n  font-size: 16px;\n  line-height: 1.25;\n}\n.rx-content dfn,\n.rx-content abbr {\n  font-size: 95%;\n}\n.rx-content cite,\n.rx-content small,\n.rx-content var,\n.rx-content kbd,\n.rx-content code {\n  font-size: 85%;\n}\n.rx-content sup,\n.rx-content sub {\n  font-size: 65%;\n}\n.rx-content var,\n.rx-content code,\n.rx-content kbd {\n  display: inline-block;\n  font-family: var(--rx-font-mono);\n  font-style: normal;\n  line-height: 1;\n  vertical-align: baseline;\n}\n.rx-content kbd,\n.rx-content code {\n  border-radius: 4px;\n}\n.rx-content kbd {\n  color: var(--rx-kbd-color);\n  background: var(--rx-kbd-bg);\n  border: 1px solid var(--rx-kbd-border);\n  padding: 0.2em 0.4em;\n}\n.rx-content var {\n  color: var(--rx-var-color);\n}\n.rx-content code {\n  position: relative;\n  top: -1px;\n  padding: 0.2em 0.4em 0.2em;\n  color: var(--rx-code-color);\n  background: var(--rx-code-bg);\n  border: 1px solid var(--rx-code-border);\n}\n.rx-content mark {\n  background-color: #FFEA80;\n  color: black;\n}\n.rx-content b,\n.rx-content strong {\n  font-weight: bold;\n}\n.rx-content dfn,\n.rx-content abbr[title] {\n  letter-spacing: 0.01em;\n  text-transform: uppercase;\n  text-decoration: none;\n  border-bottom: 1px dotted var(--rx-abbr-border);\n  cursor: help;\n}\n.rx-content cite {\n  color: var(--rx-cite-color, var(--rx-text-color));\n  font-style: italic;\n}\n.rx-content sub,\n.rx-content sup {\n  line-height: 1;\n  margin-left: 2px;\n}\n.rx-content sub {\n  vertical-align: sub;\n}\n.rx-content sup {\n  vertical-align: super;\n}\n.rx-content ul {\n  list-style: disc;\n}\n.rx-content ol {\n  list-style: decimal;\n}\n.rx-content ol > li > ol {\n  list-style-type: lower-alpha;\n}\n.rx-content ol > li > ol > li > ol {\n  list-style-type: lower-roman;\n}\n.rx-content ul,\n.rx-content ol {\n  padding-left: 0;\n  margin-left: 20px;\n}\n.rx-content li li {\n  font-size: 1em;\n}\n.rx-content dt {\n  font-weight: bold;\n}\n.rx-content dd + dt {\n  margin-top: 0.25em;\n}\n.rx-content pre {\n  overflow: auto;\n  white-space: pre;\n  font-family: var(--rx-font-mono);\n  font-size: 14px;\n  line-height: 1.6;\n  padding: 1em;\n  border-radius: 3px;\n  border: 1px solid var(--rx-pre-border, transparent);\n  background: var(--rx-pre-bg, transparent);\n  color: var(--rx-pre-color, var(--rx-text-color));\n}\n.rx-content pre code {\n  position: initial;\n  color: inherit;\n  white-space: pre;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  display: block;\n  line-height: inherit;\n  background: none;\n}\n.rx-content blockquote,\n.rx-content figure:has(blockquote) {\n  padding: 0;\n  background: var(--rx-quote-bg, transparent);\n  padding-left: 24px;\n  border-left: var(--rx-quote-border-width, 3px) solid var(--rx-quote-border-color);\n}\n.rx-content blockquote p,\n.rx-content figure:has(blockquote) p {\n  font-style: italic;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.4;\n  color: var(--rx-quote-color, var(--rx-text-color));\n}\n.rx-content blockquote p + p,\n.rx-content figure:has(blockquote) p + p {\n  margin-top: 0.5em;\n}\n.rx-content figure:has(blockquote) blockquote {\n  padding: 0;\n  border: none;\n  box-shadow: none;\n  background: transparent;\n  border-radius: 0;\n}\n.rx-content blockquote cite,\n.rx-content figcaption cite {\n  font-style: italic;\n  font-weight: normal;\n  color: var(--rx-quote-caption-color, var(--rx-text-color));\n  font-size: 14px;\n  line-height: 1.3;\n}\n.rx-content caption {\n  text-align: left;\n  font-style: normal;\n}\n.rx-content table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n  empty-cells: show;\n  font-size: 15px;\n  line-height: 1.5;\n  color: var(--rx-table-color, var(--rx-text-color));\n}\n.rx-content td,\n.rx-content th {\n  text-align: left;\n  vertical-align: top;\n  padding: 0.75em;\n  border: 1px solid var(--rx-table-border);\n}\n.rx-content th {\n  font-weight: normal;\n}\n.rx-content thead th {\n  font-weight: bold;\n}\n.rx-content address {\n  font-style: italic;\n}\n.rx-content figcaption {\n  display: block;\n  margin-top: 4px;\n  font-size: 14px;\n  line-height: 1.3;\n  background: var(--rx-caption-bg, transparent);\n  color: var(--rx-caption-color, var(--rx-text-color));\n}\n.rx-content figure > img, .rx-content figure > img a, .rx-content figure > iframe, .rx-content figure > pre, .rx-content figure > div {\n  vertical-align: middle;\n}\n.rx-content .embed-responsive:has(iframe) {\n  position: relative;\n  padding: 0;\n  padding-bottom: 56.25%;\n  height: 0;\n}\n.rx-content .embed-responsive:has(iframe) iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.rx-content div.embed-responsive {\n  margin: 0;\n}\n.rx-content hr {\n  --rx-line-size: 1px;\n  --rx-line-width: 100%;\n  --rx-line-style: solid;\n  position: relative;\n  line-height: 1;\n  background: none;\n  border: none !important;\n  text-align: left;\n  padding-top: 1.5em;\n  padding-bottom: 1.5em;\n  margin: 0 !important;\n  opacity: 1;\n  width: auto;\n}\n.rx-content hr:after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  width: var(--rx-line-width);\n  max-width: var(--rx-line-width);\n  margin-top: -calc(var(--rx-line-size)/2);\n  border-top-width: var(--rx-line-size);\n  border-top-style: var(--rx-line-style);\n  border-top-color: var(--rx-line-color);\n}\n.rx-content .wrap-center {\n  text-align: center;\n}\n.rx-content .wrap-center img {\n  margin-left: auto;\n  margin-right: auto;\n}\n.rx-content .wrap-center figcaption {\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n.rx-content .float-left {\n  float: left;\n  margin-right: 1em;\n  margin-bottom: 1em;\n  max-width: 200px;\n}\n.rx-content .float-right {\n  float: right;\n  margin-left: 1em;\n  margin-bottom: 1em;\n  max-width: 200px;\n}\n.rx-content .outset-right {\n  position: relative;\n  width: calc(100% + var(--rx-outset-md));\n  max-width: calc(100% + var(--rx-outset-md));\n  transform: translateX(var(--rx-outset-md)) translate3d(0, 0, 0);\n  left: calc(var(--rx-outset-md) * -1);\n}\n.rx-content .outset-left {\n  width: calc(100% + var(--rx-outset-md));\n  max-width: calc(100% + var(--rx-outset-md));\n  transform: translateX(calc(var(--rx-outset-md) * -1)) translate3d(0, 0, 0);\n}\n.rx-content .outset-both {\n  position: relative;\n  width: calc(100% + var(--rx-outset-md) + var(--rx-outset-md));\n  max-width: calc(100% + var(--rx-outset-md) + var(--rx-outset-md));\n  transform: translateX(-50%) translate3d(0, 0, 0);\n  left: 50%;\n}\n\n.rx-editor-wym h1,\n.rx-editor-wym h2,\n.rx-editor-wym h3,\n.rx-editor-wym h4,\n.rx-editor-wym h5,\n.rx-editor-wym h6,\n.rx-editor-wym ul:not([data-structure=false]),\n.rx-editor-wym ol:not([data-structure=false]),\n.rx-editor-wym dl,\n.rx-editor-wym address,\n.rx-editor-wym p {\n  position: relative;\n  background: var(--rx-bg-base);\n  padding: 8px 12px;\n}\n.rx-editor-wym h1:after,\n.rx-editor-wym h2:after,\n.rx-editor-wym h3:after,\n.rx-editor-wym h4:after,\n.rx-editor-wym h5:after,\n.rx-editor-wym h6:after,\n.rx-editor-wym ul:not([data-structure=false]):after,\n.rx-editor-wym ol:not([data-structure=false]):after,\n.rx-editor-wym dl:after,\n.rx-editor-wym address:after,\n.rx-editor-wym p:after {\n  position: absolute;\n  font-size: 11px;\n  font-weight: normal;\n  top: 2px;\n  right: 4px;\n  cursor: pointer;\n  color: var(--rx-fg-placeholder);\n}\n.rx-editor-wym h1:empty::before,\n.rx-editor-wym h2:empty::before,\n.rx-editor-wym h3:empty::before,\n.rx-editor-wym h4:empty::before,\n.rx-editor-wym h5:empty::before,\n.rx-editor-wym h6:empty::before,\n.rx-editor-wym ul:not([data-structure=false]):empty::before,\n.rx-editor-wym ol:not([data-structure=false]):empty::before,\n.rx-editor-wym dl:empty::before,\n.rx-editor-wym address:empty::before,\n.rx-editor-wym p:empty::before {\n  content: \"​\";\n  display: inline-block;\n}\n.rx-editor-wym pre {\n  position: relative;\n}\n.rx-editor-wym pre:after {\n  position: absolute;\n  font-size: 11px;\n  font-weight: normal;\n  top: 2px;\n  right: 4px;\n  cursor: pointer;\n  color: var(--rx-fg-placeholder);\n}\n.rx-editor-wym ul:not([data-structure=false]) ul,\n.rx-editor-wym ol:not([data-structure=false]) ol {\n  outline: 1px solid var(--rx-border-divider) !important;\n}\n.rx-editor-wym ul:not([data-rx-type=todo]),\n.rx-editor-wym ol {\n  margin-left: 0;\n  padding-left: 24px;\n  margin-bottom: 3px;\n}\n.rx-editor-wym ol:not([data-structure=false]):after {\n  content: \"ol\";\n}\n.rx-editor-wym ul:not([data-structure=false]):after {\n  content: \"ul\";\n}\n.rx-editor-wym dl:after {\n  content: \"dl\";\n}\n.rx-editor-wym h1:after {\n  content: \"h1\";\n}\n.rx-editor-wym h2:after {\n  content: \"h2\";\n}\n.rx-editor-wym h3:after {\n  content: \"h3\";\n}\n.rx-editor-wym h4:after {\n  content: \"h4\";\n}\n.rx-editor-wym h5:after {\n  content: \"h5\";\n}\n.rx-editor-wym h6:after {\n  content: \"h6\";\n}\n.rx-editor-wym p:after {\n  content: \"p\";\n}\n.rx-editor-wym pre:after {\n  content: \"pre\";\n}\n.rx-editor-wym address:after {\n  content: \"address\";\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
